import React, { useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import Logo from "./video/Mariniz Logo Gold.png";

import axios from "axios";
import { formatDistanceToNow } from "date-fns";
import config from "../function/config";
import HomeNav from "./Navbars/HomeNav";
import Footer from "./Footer";
import { toast } from "react-toastify";
import NewHomeNav from "./Navbars/NewHomeNav";

export default function Logistics() {
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [ports, setPorts] = useState([]);
  const [count, setCount] = useState(0);

  const [allShips, setallShips] = useState([]);
  const [allShipsReg, setallShipsReg] = useState([]);
  const [filteredShips, setFilteredShips] = useState([]);
  const [selectedView, setSelectedView] = useState("ship"); // "ship" or "cargo"
  const [refPage, setRefPage] = useState(1);

  const navigate = useNavigate();

  const [hoverCountry, setHoverCountry] = useState("");
  const [selectedPort, setSelectedPort] = useState("");
  const [countryQuery, setCountryQuery] = useState("");


  const [dischargeCountry, setDischargeCountry] = useState("");
  
  const [dropdownOpenDis, setDropdownOpenDis] = useState(false);
  const [hoverCountryDis, setHoverCountryDis] = useState("");
  const [countryQueryDis, setCountryQueryDis] = useState("");

  const countriesWithPorts = {
    Antigua: {
      flag: "",
      ports: ["St John’s"],
    },
    Angola: {
      flag: "",
      ports: [
        "Cabinda",
        "Futila Terminal",
        "Lobito",
        "Luanda",
        "Mocamedes",
        "Namibe",
        "Porto Saco",
      ],
    },
    Algeria: {
      flag: "",
      ports: [
        "Algiers",
        "Annaba",
        "Arzew",
        "Arzew El-Djedid",
        "Bejala",
        "Bethioua",
        "Bone",
        "Mostaganem",
        "Oran",
        "Philippeville",
        "Port Methanier",
        "Skikda",
      ],
    },
    Albania: {
      flag: "",
      ports: ["Vlone", "Vlore"],
    },
    Argentina: {
      flag: "",
      ports: [
        "Bahia Blanca",
        "Buenos Aires",
        "Caleta Cordova",
        "Caleta Olivares",
        "Caleta Olivia",
        "Campana",
        "Comodoro Rivadavia",
        "Diamante",
        "General Lagos",
        "Ibicuy",
        "Ingeniero Buitrango",
        "Ingeniero White",
        "La Plata",
        "Puerto Acevedo",
        "Puerto Belgrano",
        "Puerto Galvan",
        "Puerto Ingeniero Rocca",
        "Puerto Madryn",
        "Puerto Martins",
        "Puerto Parana",
        "Puerto Rosales",
        "Punta Alvear",
        "Punta Ancla",
        "Punta Ciguena",
        "Punta Loyola",
        "Ramallo",
        "Rio Gallegos",
        "Rosario",
        "San Lorenzo",
        "San Martin",
        "San Nicolas",
        "San Pedro",
        "San Sebastian Bay",
        "Santa Fe",
        "Villa Constitucion",
        "Zarate",
      ],
    },
    "Ascension Island": {
      flag: "",
      ports: ["Clarence Bay", "English Bay", "Georgetown"],
    },
    Aruba: {
      flag: "",
      ports: ["Barcadera", "Oranjestad", "San Nicolas"],
    },
    Australia: {
      flag: "",
      ports: [
        "Abbot Point",
        "Adelaide",
        "Albany",
        "Ball’s Head",
        "Ballast Point",
        "Balmain",
        "Barney Point",
        "Barrow Island",
        "Beauty Point Harbour",
        "Bell Bay",
        "Berry’s Bay",
        "Blackwattle Bay",
        "Boston Bay",
        "Botany Bay",
        "Bowen",
        "Brisbane",
        "Bunbury",
        "Bundaberg",
        "Burnie",
        "Cairns",
        "Carnarvon",
        "Cooktown",
        "Cossack Pioneer Terminal",
        "Crib Point",
        "Dalrymple Bay",
        "Dampier",
        "Darling Harbour",
        "Darwin",
        "Devonport",
        "East Intercourse Island",
        "Eden",
        "Emu Bay",
        "Esperance",
        "Finucane Island",
        "Fisherman Islands",
        "Fremantle",
        "Geelong",
        "George Town",
        "Geraldton",
        "Gladstone",
        "Glebe Island",
        "Gore Bay",
        "Gove",
        "Groote Eylandt",
        "Hastings",
        "Hay Point",
        "Hobart",
        "Humbug Point",
        "Koolan Island",
        "Kurnell",
        "Kwinana",
        "Launceston",
        "Long Island Point",
        "Long Reach",
        "Lorim Point",
        "Mackay",
        "Macquarie Point",
        "Melbourne",
        "Miner Bay",
        "Mistaken Island",
        "Munganno Point",
        "Nelson Point",
        "Newcastle",
        "Parker Point",
        "Perth",
        "Pinkenba",
        "Port Alma",
        "Port Augusta",
        "Port Botany",
        "Port Hedland",
        "Port Jackson",
        "Port Kembla",
        "Port Kennedy",
        "Port Latta",
        "Port Lincoln",
        "Port Pirie",
        "Port Stanvac",
        "Port Walcott",
        "Porter Bay",
        "Portland",
        "Princess Royal Harbour",
        "Proper Bay",
        "Pyrmont",
        "Risdon",
        "Rockhampton",
        "Self’s Point",
        "Snail’s Bay",
        "Snug Cove",
        "Spalding Cove",
        "Stanley",
        "Sydney",
        "Sydney Cove",
        "Thursday Island",
        "Townsville",
        "Trial Bay",
        "Twofold Bay",
        "Urangan",
        "Wallaroo",
        "Weipa",
        "Western Port",
        "White Bay",
        "Whyalla",
        "Withnell Bay",
        "Wyndham",
        "Yampi Sound",
      ],
    },
    Bahamas: {
      flag: "",
      ports: ["Clifton Point", "Freeport", "Nassau"],
    },
    Bahrain: {
      flag: "",
      ports: ["Mina Salman", "Sitra"],
    },
    Bangladesh: {
      flag: "",
      ports: ["Chalna", "Chittagong", "Khulna", "Mongla"],
    },
    Barbados: {
      flag: "",
      ports: [
        "Black Rock Tanker Terminal",
        "Bridgetown",
        "Needham’s Point Tanker Terminal",
        "Olistins Bay Tanker Terminal",
        "Spring Garden Tanker Terminal",
      ],
    },
    Belgium: {
      flag: "",
      ports: ["Antwerp", "Bruges", "Ghent", "Ostend", "Zeebrugge"],
    },
    Belize: {
      flag: "",
      ports: ["Belize City"],
    },
    Benin: {
      flag: "",
      ports: ["Cotonou"],
    },
    Bermuda: {
      flag: "",
      ports: ["Freeport", "Hamilton"],
    },
    Azores: {
      flag: "",
      ports: ["Horta", "Ponta Delgada"],
    },
    Brazil: {
      flag: "",
      ports: [
        "Admiral Barroso Terminal",
        "Alemoa Terminal",
        "Antonina",
        "Aracaju",
        "Aratu",
        "Barao De Tefe",
        "Barnabe Island Terminal",
        "Belem",
        "Butadeine Dock Island",
        "Cabedelo",
        "Conceicaoziinha Terminal",
        "Cosipa Terminal",
        "Cutrale Terminal",
        "DTSE/GEGUA Oil Terminal",
        "Fortaleza",
        "Governor’s Island",
        "Ilha Redonda",
        "Itaqui",
        "Maceio",
        "Madre Deus",
        "Manaus",
        "Miramar Oil Terminal",
        "Mucuripe",
        "Natal",
        "Niteroi",
        "Paranagua",
        "Ponta da Madeira",
        "Porto Alegre",
        "Praia Mole",
        "Recife",
        "Redonda Island",
        "Rio de Janeiro",
        "Rio Grande",
        "Salvador",
        "Santos",
        "Sao Cristovao",
        "Sao Luis",
        "Sao Sebastiao",
        "Torgua",
        "Tramandai",
        "Tubarao",
        "Ultrafertil Terminal",
        "Vitoria",
      ],
    },
    "Cameroon Republic": {
      flag: "",
      ports: ["Bonaberi", "Douala", "Limbe", "Limboh Terminal", "Victoria"],
    },
    Bulgaria: {
      flag: "",
      ports: ["Bourgas", "Pomorie", "Sozopol", "Tzarevo", "Varna"],
    },
    "Brunei Darussalam": {
      flag: "",
      ports: ["Kuala Belait", "Seria"],
    },
    Canada: {
      flag: "",
      ports: [
        "Argentia",
        "Baie Verte",
        "Baie-Comeau",
        "Bathurst",
        "Bayside",
        "Belledune",
        "Berrypoint",
        "Botwood",
        "Brooklyn",
        "Burlington Bay",
        "Campbell River",
        "Canaport",
        "Chandler",
        "Charlottetown",
        "Chatham",
        "Chicoutimi",
        "Churchill",
        "Clarenville",
        "Clarkson",
        "Come By Chance",
        "Comeau Bay",
        "Corner Brook",
        "Dalhousie",
        "Duke Point",
        "Duncan Bay",
        "Esquimalt",
        "Fairview Cove",
        "Frobisher",
        "Gold River",
        "Goose Bay",
        "Halifax",
        "Hamilton",
        "Havre St Pierre",
        "Holyrood",
        "Humbermouth",
        "Iqaluit",
        "Kingston",
        "Kingsville",
        "Kitimat",
        "Lewisporte",
        "Liverpool",
        "Long Harbour",
        "Matane",
        "McKellar Island",
        "Middle Point",
        "Mission River",
        "Mont Louis",
        "Montreal",
        "Mulgrave",
        "Nanaimo",
        "New Glasgow & Trenton",
        "New Richmond",
        "Newcastle",
        "North Sydney",
        "Ocean Falls",
        "Ogden Point",
        "Pictou",
        "Point Tupper",
        "Pointe Aux Basques",
        "Pointe Noire",
        "Port Alberni",
        "Port Alfred",
        "Port Alice",
        "Port aux Basques",
        "Port Cartier",
        "Port Harmon",
        "Port Hawkesbury",
        "Port Medway",
        "Port Saguenay",
        "Port Stanley",
        "Powell River",
        "Prince Rupert",
        "Quebec",
        "Ridley Island",
        "Rimouski",
        "Roberts Bank",
        "Saint John",
        "Sarnia",
        "Sept-Iles",
        "Seven Islands",
        "Shelburne",
        "Sorel",
        "St Andrews",
        "St John’s",
        "St Romuald",
        "Stephenville",
        "Stewart",
        "Sydney",
        "Tahsis",
        "Thunder Bay",
        "Toronto",
        "Trois-Rivieres",
        "Vancouver",
        "Victoria",
        "Whiffen Head",
        "Windsor",
        "Yarmouth",
      ],
    },
    "Cayman Islands": {
      flag: "",
      ports: ["Georgetown"],
    },
    "Cape Verde Islands": {
      flag: "",
      ports: [
        "Mindelo",
        "Palmeira Bay",
        "Pedra De Lume",
        "Porto Grande",
        "Sal Island",
        "Santa Maria Bay",
      ],
    },
    "Canary Islands": {
      flag: "",
      ports: [
        "Las Palmas",
        "Puerto Caballo Oil Terminal",
        "Puerto de la Hondura Oil Terminal",
        "Puerto de La Luz y Las Palmas",
        "Santa Cruz de Tenerife",
      ],
    },
    Chile: {
      flag: "",
      ports: [
        "Antofagasta",
        "Arica",
        "Barquito",
        "Cabo Negro",
        "Calbuco",
        "Caldera",
        "Caleta Clarencia",
        "Caleta Coloso",
        "Caleta Ossa",
        "ChanaraI",
        "Coquimbo",
        "Corrale",
        "Cutter Cove",
        "Gregorio",
        "Guacolda",
        "Guayacan",
        "Huasco",
        "Iquique",
        "La Chimba Cove",
        "Laredo",
        "Las Losas",
        "Las Salinas",
        "Lendaura",
        "Lirquen",
        "Pecket",
        "Porvenir",
        "Puerto Coralle",
        "Puerto Corral",
        "Puerto Montt",
        "Puerto Percy",
        "Puerto Ventanas",
        "Punta Arenas",
        "Quintero",
        "San Antonio",
        "San Gregorio",
        "San Vicente",
        "Santa Barbara",
        "Talcahuano",
        "Taltal",
        "Tocopilla",
        "Valdivia",
        "Valparaiso",
      ],
    },
    China: {
      flag: "",
      ports: [
        "Amoy",
        "Baoshan",
        "Bayuquan",
        "Beijang",
        "Canton",
        "Chefoo",
        "Chinwangtao",
        "Dagang",
        "Dairen",
        "Dalian",
        "Dayao Bay",
        "Dongdu",
        "Fuzhou",
        "Foochow",
        "Ganjingzi",
        "Guangzhou",
        "Handi",
        "Hankow",
        "Heizluzui",
        "Heshangdao",
        "Hong Kong",
        "Huangdao",
        "Huangpu",
        "Nanjing",
        "Nianyuwan",
        "Qianwan",
        "Qingdao",
        "Qinhuangdao",
        "Shanghai",
        "Shantou",
        "Siergou",
        "Swatow",
        "Taku Bar",
        "Tanggu",
        "Tianjin",
        "Tsamkong",
        "Tsingtao",
        "Wei Hai",
        "Wuhan",
        "Xiahai",
        "Xiamen",
        "Xianglujiao",
        "Xidi",
        "Xigang",
        "Xingang",
        "Xinshenwei",
        "Yantai",
        "Yingkou",
        "Zhanjiang",
      ],
    },
    "Cocos Islands": {
      flag: "",
      ports: ["Port Refuge"],
    },
    "Christmas Island": {
      flag: "",
      ports: ["Christmas Island"],
    },
    Colombia: {
      flag: "",
      ports: [
        "Barranquilla",
        "Buenaventura",
        "Cartagena",
        "Cienaga",
        "Covenas Offshore Terminal",
        "Ecopetrol",
        "Mamonal",
        "Monomeros",
        "Muelles El Bosque",
        "Pindo",
        "Pozos Colorados",
        "Puerto Prodeco",
        "Puerto Zuniga",
        "Santa Marta",
        "Tolu",
        "Tumaco",
      ],
    },
    "Costa Rica": {
      flag: "",
      ports: [
        "Golfito",
        "Golfo Dulce",
        "Puerto Limon",
        "Puerto Moin",
        "Puntarenas",
        "Quepos",
      ],
    },
    "Congo (Democratic Republic)": {
      flag: "",
      ports: ["Ango-Ango", "Banana", "Boma", "Matadi", "Moanda Oil Terminal"],
    },
    "Congo (Republic of Congo)": {
      flag: "",
      ports: ["Pointe-Noire"],
    },
    Comoros: {
      flag: "",
      ports: [
        "Dzaoudzi",
        "Longoni",
        "Mamoudzou",
        "Mayotte",
        "Moroni",
        "Pamandzi Bay",
      ],
    },
    Croatia: {
      flag: "",
      ports: [
        "Bakar",
        "Dubrovnik",
        "Gazenica",
        "Krk Island",
        "Luka Gruz",
        "Omisalj",
        "Pula",
        "Rijeka",
        "Rijeka Dubrovačka",
        "Sepen",
        "Sibenik",
        "Split",
        "Srećica",
        "Susak",
        "Urinj",
        "Zadar",
      ],
    },
    Cuba: {
      flag: "",
      ports: [
        "Antilla",
        "Banes",
        "Caibarien",
        "Cardenas",
        "Casilda",
        "Cayo Frances",
        "Cienfuegos",
        "Felton",
        "Guantanamo",
        "Havana",
        "Macabi",
        "Manzanillo",
        "Mariel",
        "Matanzas",
        "Nuevitas",
        "Pastellilo",
        "Preston",
        "Puerto Padre",
        "Puerto Tarafa",
        "Santiago de Cuba",
        "Tarafa",
      ],
    },
    Cyprus: {
      flag: "",
      ports: [
        "Akrotiri",
        "Dhekelia",
        "Famagusta",
        "Gemikonagi",
        "Karavostassi",
        "Larnaca",
        "Limassol",
        "Moni",
        "Morphou Bay",
        "Paphos",
        "Vassiliko",
        "Xeros",
      ],
    },
    Denmark: {
      flag: "",
      ports: [
        "Aabenraa",
        "Aalborg",
        "Aarhus",
        "Asnaesvaerkets Havn",
        "Avernakke",
        "Copenhagen",
        "Ebeltoft",
        "Elsinore",
        "Ensted",
        "Esbjerg",
        "Fredericia",
        "Frederikshavn",
        "Frederikssund",
        "Gulfhavn",
        "Helsingor",
        "Horsens",
        "Kalundborg",
        "Karrebaeksminde",
        "Koge",
        "Kolding",
        "Korsoer",
        "Kyndby",
        "Lindholm",
        "Lindoe Terminal",
        "Lyngs Odde",
        "Masnedsvaerkets Havn",
        "Naestved",
        "Nyborg",
        "Odense",
        "Orehoevd",
        "Ronne",
        "Rudkobing",
        "Skaelskor",
        "Skaerbaek",
        "Skagen",
        "Stigsnaesvaerkets Havn",
        "Svendborg",
        "Tuborg",
        "Vordingborg",
      ],
    },
    Ecuador: {
      flag: "",
      ports: [
        "Andiport",
        "Balao Terminal",
        "Esmeraldas",
        "Guayaquil",
        "La Libertad",
        "Terpe Terminal",
      ],
    },
    "Dominican Republic": {
      flag: "",
      ports: [
        "Barahona",
        "Cabo Rojo",
        "Ciudad Trujillo",
        "La Romana",
        "Manzanillo",
        "San Pedro de Macoris",
        "Sans Souci",
        "Santo Domingo",
      ],
    },
    Dominica: {
      flag: "",
      ports: ["Roseau", "Woodbridge Bay"],
    },
    Djibouti: {
      flag: "",
      ports: ["Djibouti"],
    },
    Egypt: {
      flag: "",
      ports: [
        "Abu Zenima",
        "Adabiya",
        "Alexandria",
        "Ataqa",
        "El Alamein",
        "El Dekheila",
        "El Meks",
        "Hurghada",
        "Kosseir",
        "Mersa el Hamra",
        "Port Ibrahim",
        "Port Said",
        "Port Tewfik",
        "Quseir",
        "Ras Budran",
        "Ras Gharib",
        "Ras Shukheir",
        "Ras Sudr",
        "Safaga",
        "Suez",
        "Wadi Feiran",
      ],
    },
    Fiji: {
      flag: "",
      ports: ["Lautoka", "Suva", "Walu Bay"],
    },
    "Faroe Islands": {
      flag: "",
      ports: [
        "Drelnes",
        "Fuglafjordur",
        "Klaksvik",
        "Kollafjordur",
        "Midvaag",
        "Runavik",
        "Skaala",
        "Soervaag",
        "Strendur",
        "Torshavn",
        "Trangisvaag",
        "Tvoroyri",
        "Vagu",
        "Vestmanna",
      ],
    },
    "Falkland Islands": {
      flag: "",
      ports: ["Port Stanley", "Stanley"],
    },
    Estonia: {
      flag: "",
      ports: [
        "Kesklinna",
        "Kopli-Port Of Tallinn",
        "Muuga-Port Of Tallinn",
        "Novotalinsky",
        "Old City Harbour-Port of Tallinn",
        "Paldiski-Port Of Tallinn",
        "Paljassaare",
        "Tallinn",
      ],
    },
    Eritrea: {
      flag: "",
      ports: ["Assab", "Massawa"],
    },
    "Equatorial Guinea": {
      flag: "",
      ports: ["Malabo", "Punta Europa Terminal", "Rey Malabo"],
    },
    "El Salvador": {
      flag: "",
      ports: ["Acajutla", "Acajutla Offshore Terminal", "Cutuco", "La Union"],
    },
    Finland: {
      flag: "",
      ports: [
        "Abo",
        "Ajos",
        "Haakoninlahti",
        "Hamina",
        "Hanko",
        "Haponniemi",
        "Helsinki",
        "Hepokari",
        "Inkoo",
        "Jakobstad",
        "Kemi",
        "Kokkola",
        "Kotka",
        "Kristinestad",
        "Laajasalo Oil Harbour",
        "Loviisa",
        "Mantyluoto",
        "Naantali",
        "Nuottasaari",
        "Oritkari",
        "Oulu",
        "Pansio",
        "Pateniemi",
        "Pietarsaari",
        "Pori",
        "Porvoo",
        "Rauma",
        "Reposaari",
        "Tolkkinen-Tolkis",
        "Toppila",
        "Turku",
        "Uusikaupunki",
        "Veitsiluoto",
        "Vihreasaari",
        "Vuosaari Harbour",
        "Ykspihlaja",
      ],
    },
    France: {
      flag: "",
      ports: [
        "Ajaccio",
        "Ambes",
        "Antibes",
        "Antifer",
        "Basse Indre",
        "Bassens",
        "Bastia",
        "Bayonne",
        "Bec d’ Ambes",
        "Blaye",
        "Bordeaux",
        "Boulogne-sur-Mer",
        "Brest",
        "Caen",
        "Calais",
        "Cannes",
        "Caronte",
        "Cherbourg",
        "Cordemais",
        "Corniguel",
        "Coueron",
        "Dieppe",
        "Donges",
        "Dunkirk",
        "Etang de Berre",
        "Fos",
        "Gravenchon",
        "Haut Indre",
        "Honfleur",
        "Indret",
        "La Ciotat",
        "La Mede",
        "La Nouvelle",
        "La Pallice",
        "La Pointe de Berre",
        "La Rochelle",
        "La Rochelle-Pallice",
        "La Seyne-Bregaillon",
        "Lavera",
        "Le Havre",
        "Le Verdon",
        "Lorient",
        "Marseilles",
        "Montoir",
        "Nantes-St Nazaire",
        "Nice",
        "Paimboeuf",
        "Pauillac",
        "Petit Couronne",
        "Port de Bouc",
        "Port Jerome",
        "Port St Louis du Rhone",
        "Port St Nicholas",
        "Port Toga",
        "Port Tudy",
        "Quimper-Corniguel",
        "Rouen",
        "Sete",
        "St Malo",
        "St Nazaire",
        "Toulon La Seyne",
        "Villefranche",
      ],
    },
    Georgia: {
      flag: "",
      ports: ["Batumi", "Poti"],
    },
    Gambia: {
      flag: "",
      ports: ["Banjul"],
    },
    Gabon: {
      flag: "",
      ports: ["Gamba", "Libreville", "Ovendo", "Owendo", "Port Gentil"],
    },
    "French Polynesia": {
      flag: "",
      ports: ["Papeete"],
    },
    Germany: {
      flag: "",
      ports: [
        "Blexen",
        "Brake",
        "Bremen",
        "Bremerhaven",
        "Brunsbuttel",
        "Butzfleth",
        "Cuxhaven",
        "Elbeharbour",
        "Elsfleth",
        "Emden",
        "Flensburg",
        "Hamburg",
        "Holtenau",
        "Kiel",
        "Kiel-Holtenau",
        "Laboe",
        "Lubeck",
        "Nordenham",
        "Ostermoor",
        "Rostock",
      ],
    },
    Gibraltar: { flag: "", ports: ["Gibraltar"] },
    Ghana: { flag: "", ports: ["Takoradi", "Tema"] },
    Greece: {
      flag: "",
      ports: [
        "Acandia",
        "Adamas",
        "Aghios Nikolaos",
        "Agia Marina",
        "Agia Trias",
        "Agioi Theodoroi",
        "Argostoli",
        "Aspraspitia Ore Terminal",
        "Aspropyrgos",
        "Ayia Marina",
        "Ayios Nikolaos",
        "Canea",
        "Cephalonia",
        "Corfu (Kerikra)",
        "Corinth",
        "Corinth Canal",
        "Drapetsona Bay",
        "Elefsis",
        "Eleusis",
        "Foron Bay",
        "Gera Bay",
        "Hercules Port",
        "Iraklion",
        "Isthmia",
        "Kalamaki",
        "Kalamata",
        "Kali Limenes",
        "Kavala",
        "Kithira",
        "Kos",
        "Lamia",
        "Leros Island",
        "Lixouri",
        "Malagari",
        "Mandraki",
        "Mandukio",
        "Marathocampos",
        "Megara Oil Terminal",
        "Microlimano",
        "Milos Island",
        "Mitilene",
        "Nafplion",
        "Nauplia",
        "Pachi",
        "Pamfila",
        "Paroikia",
        "Paros",
        "Patras",
        "Perama",
        "Phaleron Bay",
        "Piraeus",
        "Poseidonia",
        "Prinos",
        "Pylos",
        "Pythagorio",
        "Rhodes",
        "Rion",
        "Salonica",
        "Samos",
        "Skaramanga",
        "Souda Bay",
        "St George Harbour",
        "Stylis",
        "Suda Bay",
        "Syros Island",
        "Thessaloniki",
        "Volos",
        "Voudhia Bay",
        "Zakinthos",
        "Zante",
        "Zea",
      ],
    },
    Guyana: { flag: "", ports: ["Georgetown"] },
    "Guinea-Bissau": { flag: "", ports: ["Bissau"] },
    Guinea: { flag: "", ports: ["Conakry"] },
    Guatemala: {
      flag: "",
      ports: [
        "Puerto Barrios",
        "Puerto Quetzal",
        "San Jose",
        "Santo Tomas de Castilla",
      ],
    },
    Guam: { flag: "", ports: ["Apra Harbour"] },
    Guadeloupe: { flag: "", ports: ["Pointe-a-Pitre"] },
    Grenada: {
      flag: "",
      ports: [
        "Grand Mal Tanker Terminal",
        "Queen’s Park Tanker Terminal",
        "St George’s",
      ],
    },
    Greenland: {
      flag: "",
      ports: [
        "Faeringehavn",
        "Godthaab",
        "Grønnedal",
        "Ivigtut",
        "Kangerlussuaq",
        "Kangilinnguit",
        "Narsarsuaq",
        "Nuuk",
        "Qaanaaq",
        "Soendre Strømfjord",
      ],
    },
    Honduras: { flag: "", ports: ["La Ceiba", "Tela"] },
    Haiti: { flag: "", ports: ["Port au Prince"] },
    "Hong Kong": {
      flag: "",
      ports: [
        "Chai Wan",
        "Hong Kong",
        "Kowloon",
        "Kwai Chung",
        "Kwun Tong",
        "Lamma Island",
        "Stonecutters Island",
        "Tap Shek Kok",
        "Tsing Yi Island",
        "Tsuen Wan",
        "Tuen Mun",
        "Wan Chai",
        "Yau Ma Tei",
      ],
    },
    Iceland: {
      flag: "",
      ports: [
        "Grundartangi",
        "Hafnarfjordur",
        "Keflavik - Njarovik",
        "Njarovik",
        "Reykjavik",
        "Seydisfjordur",
        "Straumsvik",
      ],
    },
    India: {
      flag: "",
      ports: [
        "Beypore",
        "Bheemunipatnam",
        "Bombay",
        "Budge Budge",
        "Calcutta",
        "Calicut",
        "Cannanore",
        "Chennai",
        "Cochin",
        "Jawahar Dweep",
        "Kakinada",
        "Kandia",
        "Kochi",
        "Kolkata",
        "Madras",
        "Mangalore",
        "Mormugao",
        "Mumbai",
        "New Mangalore",
        "Okha",
        "Panaji",
        "Pir Pau",
        "Pondicherry",
        "Port Blair",
        "Port Okha",
        "Tellicherry",
        "Visakhapatnam",
        "Vizag",
      ],
    },
    Indonesia: {
      flag: "",
      ports: [
        "Ambon",
        "Ampeanam",
        "Balikpapan",
        "Batu Ampar",
        "Belawan",
        "Bengkulu",
        "Benoa",
        "Biak",
        "Buatan",
        "Bunyu",
        "Cigading",
        "Cilacap",
        "Cirebon",
        "Citra Ujung Baru",
        "Dumai",
        "Gabion",
        "Gresik",
        "Jakarta",
        "Jambi",
        "Kabil",
        "Kalianget",
        "Kota Baru",
        "Kupang",
        "Labuantring",
        "Lembar",
        "Macassar",
        "Makassar",
        "Manado",
        "Medan",
        "Muntok",
        "North Pulau Laut Coal Terminal",
        "Palembang",
        "Pangkalan Susu",
        "Panjang",
        "Pare Pare",
        "Pekanbaru",
        "Plaju & Sungai Gerong",
        "Pontianak",
        "Pulau Laut",
        "Pulau Sambu",
        "Sabang",
        "Samarinda",
        "Sekupang",
        "Semarang",
        "Sibolga",
        "Sorong",
        "Sunda Kelapa",
        "Sungai Gerong",
        "Sungai Pakning",
        "Surabaya",
        "Tanjung Emas",
        "Tanjung Intan",
        "Tanjung Pandan",
        "Tanjung Perak",
        "Tanjung Priok",
        "Tanjung Uban",
        "Tarahan Terminal",
        "Tarakan Island",
        "Telok Ayer",
        "Teluk Bayur",
        "Ujung Pandang",
      ],
    },
    Iran: {
      flag: "",
      ports: [
        "Abadan",
        "Bahregan",
        "Bahregan Oil Centre (BOC)",
        "Bahrgan",
        "Bandar Abbas",
        "Bandar Imam Khomeini",
        "Bandar Mahshahr",
        "Bandar Shahid Bahonar",
        "Bandar Shahid Rejaie",
        "Barkan",
        "Bushehr",
        "Bushire",
        "Cyrus Terminal",
        "Kharg Island",
        "Khemco Terminal",
        "Lavan Island",
        "Shahid Bahonar",
        "Shahid Rajai",
        "Soroosh Terminal",
      ],
    },
    Iraq: {
      flag: "",
      ports: [
        "Abu Al Kashib",
        "Abu Flus",
        "Ashar",
        "Basrah",
        "Fao",
        "Khor Al Amaya",
        "Khor Al Zubair",
        "Maqal",
        "Sunger",
      ],
    },
    Ireland: {
      flag: "",
      ports: [
        "Aughinish",
        "Bantry",
        "Castletown Bere",
        "Cobh",
        "Cork",
        "Dinish Island",
        "Drogheda",
        "Dublin",
        "Dun Laoghaire",
        "Duncannon",
        "Foynes",
        "Galway",
        "Haulbowline",
        "Howth",
        "Kilrush",
        "Leahlill Quarry",
        "Limerick",
        "Moneypoint",
        "Rathmullen",
        "Ringaskiddy",
        "Rosslare Europort",
        "Rushbrooke",
        "Shannon Foynes Port",
        "Sligo",
        "Tarbert Island",
        "Waterford",
        "Whiddy Island",
        "Whitegate",
      ],
    },
    Israel: {
      flag: "",
      ports: ["Ashdod", "Ashkelon", "Eilat", "Haifa", "Kishon Zone"],
    },
    "Isle of Man": { flag: "", ports: ["Douglas"] },
    Italy: {
      flag: "",
      ports: [
        "Ancona",
        "Arbatax",
        "Assemini",
        "Augusta",
        "Bagnoli",
        "Bala",
        "Bari",
        "Brindisi",
        "Cagliari",
        "Castellammare di Stabia",
        "Catania",
        "Civitavecchia",
        "Crotone",
        "Falconara",
        "Fiumicino",
        "Formia",
        "Gaeta",
        "Gela",
        "Genoa",
        "La Maddalena (Cagliari)",
        "La Maddalena (Sardinia)",
        "La Spezia",
        "Leghorn",
        "Livorno",
        "Melilli Oil Terminal",
        "Messina",
        "Milazzo",
        "Monfalcone",
        "Monopoli",
        "Naples",
        "Ortona",
        "Otranto",
        "Palau",
        "Palermo",
        "Portici",
        "Porto Corsini",
        "Porto di Malamocco",
        "Porto Empedocle",
        "Porto Foxi",
        "Porto Marghera",
        "Porto Marmoreo",
        "Porto San Leonardo",
        "Porto Santo Stefano",
        "Porto Torres",
        "Pozzuoli",
        "Priolo",
        "Priolo Gargallo",
        "Punto Franco",
        "Quiliano Terminal",
        "Ravenna",
        "Reggio Calabria",
        "San Vitale",
        "Santa Panagia Bay",
        "Sarroch",
        "Savona-Vado",
        "Siracusa",
        "Talamone",
        "Taranto",
        "Termini Imerese",
        "Torre Annunziata",
        "Torre del Greco",
        "Trapani",
        "Trieste",
        "Vado Ligure",
        "Venice",
      ],
    },
    Jamaica: {
      flag: "",
      ports: [
        "Kingston",
        "Port Bustamente",
        "Port Esquivel",
        "Port Royal",
        "Salt River",
      ],
    },
    "Ivory Coast": {
      flag: "",
      ports: [
        "Abidjan",
        "Banco Bay",
        "Canal de Virdi",
        "Locodjo",
        "Port Bouet Tanker Terminal",
      ],
    },
    Japan: {
      flag: "",
      ports: [
        "Aboshi",
        "Aburakawa",
        "Aioi",
        "Amagasaki",
        "Aomori",
        "Chiba",
        "Chita",
        "Etajima",
        "Fukuyama",
        "Funakawa",
        "Hakata",
        "Hakodate",
        "Hamada",
        "Hannan",
        "Hashihama",
        "Heianza",
        "Hibikinada",
        "Higashi-Harima",
        "Higashi-Ogishima",
        "Hikari",
        "Hikoshima",
        "Himeji",
        "Hiro",
        "Hirohata",
        "Hiroshima",
        "Iho",
        "Imabari",
        "Imari",
        "Ishikara",
        "Iwakuni",
        "Izumisano",
        "Kagoshima",
        "Kainan",
        "Kakogawa",
        "Kanmon Ko",
        "Kanokawa",
        "Karita",
        "Kashima",
        "Kawasaki",
        "Keihin",
        "Kikuma",
        "Kinwan",
        "Kishiwada",
        "Kitakyushu",
        "Kobe",
        "Kokura",
        "Kudamatsu",
        "Kure",
        "Kushiro",
        "Marugame",
        "Mategata",
        "Matsuyama",
        "Mega",
        "Miike",
        "Mitsukojima",
        "Mizushima",
        "Moji",
        "Muroran",
        "Nagasaki",
        "Nagoya",
        "Naha",
        "Namikata",
        "Niigata-Higashi",
        "Niigata-Nishi",
        "Nishihara",
        "Ofunato",
        "Ogishima",
        "Oita",
        "Omishima",
        "Onoda",
        "Osaka",
        "Owase",
        "Rokko Island",
        "Sakai",
        "Sakaide",
        "Sakaiminato",
        "Sasebo",
        "Senboku",
        "Shikama",
        "Shimizu",
        "Shimonoseki",
        "Shimotsu",
        "Shirashima",
        "Susaki",
        "Takasago",
        "Takehara",
        "Tamashima",
        "Tobata",
        "Tokai",
        "Tokuyama",
        "Tonda",
        "Tokyo",
        "Toyama",
        "Toyama-Shinko",
        "Tsuruga",
        "Ube",
        "Ukishima",
        "Wakamatsu",
        "Wakayama",
        "Yawata",
        "Yokkaichi",
        "Yokohama",
        "Yokosuka",
      ],
    },
    Kenya: {
      flag: "",
      ports: [
        "Kilindi",
        "Kipevu Oil Terminal",
        "Mbaraki",
        "Mombasa",
        "Port Reitz",
        "Port Tudor",
        "Shimanzi Oil Terminal",
      ],
    },
    Jordan: { flag: "", ports: ["Aqaba", "Mo’ta", "Mushterak"] },
    Kiribati: { flag: "", ports: ["Banaba"] },
    "North Korea": { flag: "", ports: ["Hungnam"] },
    "South Korea": {
      flag: "",
      ports: ["Busan", "Inchon", "Pohang", "Pusan", "Samil", "Yeosu", "Yosu"],
    },
    Kuwait: {
      flag: "",
      ports: [
        "Mina Abdulla",
        "Mina Al Ahmadi",
        "Mina Al Zour",
        "Mina Saud",
        "Shuaiba",
        "Shuwaikh",
      ],
    },
    Latvia: { flag: "", ports: ["Lielupe", "Liepaja", "Riga", "Ventspils"] },
    Lebanon: {
      flag: "",
      ports: [
        "Beirut",
        "Dora Terminal",
        "Saida",
        "Sidon",
        "Tripoli",
        "Zahrani Terminal",
      ],
    },
    Liberia: { flag: "", ports: ["Buchanan", "Monrovia"] },
    Libya: {
      flag: "",
      ports: [
        "Benghazi",
        "Es Sider",
        "Marsa al Hariga",
        "Marsa El Brega",
        "Ras Lanuf",
        "Rasco Harbour",
        "Sirtica Terminal",
        "Tarabulus",
        "Tobruk",
        "Tripoli",
        "Zueitina",
      ],
    },
    Madeira: { flag: "", ports: ["Funchal", "Praia Formosa"] },
    Madagascar: {
      flag: "",
      ports: [
        "Andoany",
        "Antalaha",
        "Antsiranana",
        "Diego Suarez",
        "Fort Dauphin",
        "Mahajanga",
        "Majunga",
        "Manakara",
        "Mananjary",
        "Morondava",
        "Nosy Be",
        "Tamatave",
        "Toamasina",
        "Tolanaro",
        "Tulear",
      ],
    },
    Maldives: { flag: "", ports: ["Male"] },
    Lithuania: { flag: "", ports: ["Klaipeda"] },
    Malaysia: {
      flag: "",
      ports: [
        "Biawak",
        "Butterworth",
        "Datuk Sim Kheng Hong",
        "Johor",
        "Kota Kinabalu",
        "Kuala Baram",
        "Kuching",
        "Labuan",
        "Lutong",
        "Malacca",
        "Miri",
        "Pasir Gudang",
        "Penang",
        "Pending",
        "Port Dickson",
        "Port Kelang",
        "Port Swettenham",
        "Prai",
        "Sandakan",
        "Sejingkat",
        "Senari",
        "Sibu",
        "Sungai Udang",
        "Tanah Puteh",
        "Tanjung Bruas",
        "Tanjung Manis",
        "Tawau",
        "Teluk Anson",
        "Westport",
      ],
    },
    Mauritius: { flag: "", ports: ["Port Louis"] },
    Mauritania: {
      flag: "",
      ports: [
        "Nouadhibou",
        "Nouakchott",
        "Point Central",
        "Port de L'Amitie",
        "Port Eltenne",
      ],
    },
    Martinique: { flag: "", ports: ["Fort-de-France"] },
    Malta: { flag: "", ports: ["Marsaxlokk", "Valletta"] },
    Mexico: {
      flag: "",
      ports: [
        "Cedros Island",
        "Coatzacoalcos",
        "Ensenada",
        "Guaymas",
        "Manzanillo",
        "Mazatlan",
        "Minatitlan",
        "Morro Redondo",
        "Nanchital",
        "Pajaritos",
        "Rosarito Terminal",
        "Salina Cruz",
        "San Pedrito Port",
        "Tampico",
        "Tuxpan",
        "Veracruz",
      ],
    },
    Myanmar: {
      flag: "",
      ports: [
        "Akyab",
        "Bassein",
        "Moulmein",
        "Mawlamyine",
        "Pathein",
        "Rangoon",
        "Sittwe",
        "Yangon",
      ],
    },
    Mozambique: {
      flag: "",
      ports: [
        "Beira",
        "Maputo",
        "Matola",
        "Mozambique Island",
        "Nacala",
        "Pemba",
        "Quelimane",
      ],
    },
    Morocco: {
      flag: "",
      ports: [
        "Agadir",
        "Al Hoceima",
        "Casablanca",
        "Kenitra",
        "Mohammedia",
        "Port de Fedala",
        "Port Nador",
        "Safi",
        "Tangier",
      ],
    },
    Monaco: { flag: "", ports: ["Monaco"] },
    Micronesia: {
      flag: "",
      ports: ["Tomil Harbour", "Yap Colonia International Port"],
    },
    Nauru: { flag: "", ports: ["Nauru"] },
    Namibia: { flag: "", ports: ["Walvis Bay"] },
    Netherlands: {
      flag: "",
      ports: [
        "Amsterdam",
        "Axel Plain",
        "Beverwijk",
        "Botlek",
        "Braakman Harbour",
        "Delfzijl",
        "Den Helder",
        "Dordrecht",
        "Europoort",
        "Flushing",
        "Hansweert",
        "Hoek van Holland",
        "Hook of Holland",
        "IJmuiden",
        "Maassluis",
        "Maasvlakte",
        "Middelburg",
        "Moerdijk",
        "Pernis",
        "Port Scaldia",
        "Rotterdam",
        "Rozenburg",
        "Sas Van Gent",
        "Schiedam",
        "Terneuzen",
        "Velsen",
        "Vlaardingen",
        "Vlissingen",
        "Ymuiden",
        "Zaandam",
        "Zaanstad",
      ],
    },
    "New Caledonia": {
      flag: "",
      ports: [
        "Baie de Numbo",
        "Baie des Dames",
        "Kouaoua",
        "Noumea",
        "Poro",
        "Thio",
      ],
    },
    "Netherlands Antilles": {
      flag: "",
      ports: [
        "Bullen Bay",
        "Caracas Bay",
        "Emmastad",
        "Santa Anna Bay",
        "Schottegat",
        "Sint Michielsbay",
        "St Michel’s Bay",
        "Willemstad",
      ],
    },
    "New Zealand": {
      flag: "",
      ports: [
        "Auckland",
        "Bluff",
        "Christchurch",
        "Dunedin",
        "Eastland Port",
        "Gisborne",
        "Lyttelton",
        "Marsden Point",
        "Napier",
        "Nelson",
        "New Plymouth",
        "Otago Harbour",
        "Picton",
        "Port Chalmers",
        "Port Marlborough",
        "Port Taranaki",
        "Ravensbourne",
        "Tauranga",
        "Timaru",
        "Wanganui",
        "Wellington",
        "Whangarei",
      ],
    },
    Nigeria: {
      flag: "",
      ports: [
        "Apapa",
        "Bonny Inshore Terminal",
        "Calabar",
        "Dawes Island",
        "Dockyard Creek",
        "Escravos Oil Terminal",
        "Forcados Oil Terminal",
        "Ibeto",
        "Lagos",
        "Okrika",
        "Pennington",
        "Port Harcourt",
        "Qua Iboe",
      ],
    },
    Nicaragua: { flag: "", ports: ["Corinto", "Puerto Sandino"] },
    Norway: {
      flag: "",
      ports: [
        "Aalesund",
        "Aker Base",
        "Ardalstangen",
        "Arendal",
        "Bergen",
        "Bodo",
        "Borg Havn IKS",
        "Breivik",
        "Brevik",
        "Drammen",
        "Egersund",
        "Fagerstrand",
        "Fiborgtangen",
        "Fredrikstad",
        "Gismervoy",
        "Grenland Harbour",
        "Grimstad",
        "Haavik",
        "Halden",
        "Hammerfest",
        "Harstad",
        "Haugesund",
        "Heroya",
        "Holmen",
        "Homsvik",
        "Honningsvag",
        "Horten",
        "Hoyanger",
        "Husnes",
        "Kambo",
        "Kirkenes",
        "Kleven",
        "Kristiansand",
        "Kristiansund",
        "Langesund",
        "Larvik",
        "Mandal",
        "Melios Harbour",
        "Mjaanesholmen",
        "Mo I Rana",
        "Moss",
        "Naersnes",
        "Narvik",
        "Orkanger",
        "Oslo",
        "Porsgrunn",
        "Prostneset",
        "Rafnes",
        "Risavika",
        "Sandefjord",
        "Sandnes",
        "Sarpsborg",
        "Sjursoya",
        "Skien",
        "Skogn",
        "Slagen",
        "Sola",
        "Stavanger",
        "Svartnes",
        "Svelvik",
        "Svolvaer",
        "Tananger",
        "Tangen",
        "Thamshavn",
        "Tonsberg",
        "Tromsdalen",
        "Tromso",
        "Trondheim",
        "Vardo",
      ],
    },
    "Papua New Guinea": {
      flag: "",
      ports: ["Lae", "Lorengau", "Madang", "Port Moresby", "Rabaul"],
    },
    Panama: {
      flag: "",
      ports: [
        "Almirante",
        "Bahia Las Minas",
        "Balboa",
        "Coco Solo North",
        "Colon",
        "Cristobal",
        "Las Minas Bay",
        "Manzanillo International Terminal",
        "Rodman Naval Station",
      ],
    },
    Pakistan: { flag: "", ports: ["Juna Bunder", "Karachi"] },
    Oman: {
      flag: "",
      ports: ["Mina al Fahal", "Muscat", "Port Sultan Qaboos"],
    },
    Peru: {
      flag: "",
      ports: [
        "Cabo Blanco",
        "Callao",
        "Chimbote",
        "Coishco",
        "General San Martín",
        "Ilo",
        "La Pampilla",
        "Lobitos",
        "Matarani",
        "Mollendo",
        "Pacasmayo",
        "Paramonga",
        "Pimentel",
        "Pisco",
        "Salaverry",
        "San Nicolas",
        "Supe",
        "Talara",
      ],
    },
    Philippines: {
      flag: "",
      ports: [
        "Bais",
        "Bataan",
        "Batangas",
        "Cebu",
        "Culasi",
        "Davao",
        "Dumaguit",
        "Estancia",
        "Hondagua",
        "Iloilo",
        "Jolo",
        "Jordan",
        "Lamao",
        "Legaspi",
        "Limay",
        "Lucanin",
        "Manila",
        "Mariveles",
        "Masbate",
        "Mati",
        "Olongapo",
        "Poro Point",
        "Roxas City",
        "San Fernando",
        "San Jose",
        "Sangi",
        "Santa Ana",
        "Sasa",
        "Subic Bay",
        "Toledo (Philippines)",
        "Villanueva",
        "Zamboanga",
      ],
    },
    "Puerto Rico": {
      flag: "",
      ports: [
        "Guanica",
        "Guayanilla",
        "Las Mareas",
        "Mayaguez",
        "Ponce",
        "Porto Nuevo",
        "San Juan",
        "Tallaboa",
      ],
    },
    Portugal: {
      flag: "",
      ports: [
        "Douro",
        "Faro & Olhao",
        "Leixoes",
        "Lisbon",
        "Oporto",
        "Santa Apolonia",
        "Setubal",
      ],
    },
    Poland: {
      flag: "",
      ports: ["Gdansk", "Gdynia", "Port Polnocny", "Swinoujscie", "Szczecin"],
    },
    Qatar: {
      flag: "",
      ports: ["Doha", "Halul Island", "Mesaieed", "Umm Said"],
    },
    Romania: { flag: "", ports: ["Constantza", "Galatz"] },
    Reunion: { flag: "", ports: ["Pointe des Galets"] },
    Russia: {
      flag: "",
      ports: [
        "Archangel",
        "Bakaritsa",
        "Ekonomiya",
        "Kaliningrad",
        "Kandalaksha",
        "Leningrad",
        "Leviy Bereg",
        "Lomonosov",
        "Murmansk",
        "Novorossiysk",
        "Sheskharis",
        "St Petersburg",
        "Taganrog",
        "Tuapse",
        "Vladivostok",
        "Vyborg",
        "Yelsk",
        "Yeysk",
      ],
    },
    "South Africa": {
      flag: "",
      ports: [
        "Cape Town",
        "Durban",
        "East London",
        "Mossel Bay",
        "Port Elizabeth",
        "Port Natal",
        "Saldanha Bay",
        "Simonstown",
      ],
    },
    Somalia: {
      flag: "",
      ports: ["Berbera", "Chisimalo", "Kismayu", "Mogadiscio"],
    },
    "Solomon Islands": { flag: "", ports: ["Honiara", "Point Cruz"] },
    Slovenia: { flag: "", ports: ["Izola", "Koper", "Piran"] },
    Singapore: {
      flag: "",
      ports: [
        "Brani Terminal",
        "Jurong",
        "Keppel",
        "Pasir Panjang",
        "Pulau Ayer Chawan",
        "Pulau Bukom",
        "Pulau Merlimau",
        "Pulau Pesek",
        "Pulau Sebarok",
        "Sembawang",
        "Singapore",
        "Tanjong Pagar",
      ],
    },
    "Sierra Leone": {
      flag: "",
      ports: ["Freetown", "Kissy Oil Terminal", "Pepel"],
    },
    Seychelles: { flag: "", ports: ["Mahe", "Port Victoria"] },
    "Serbia & Montenegro": { flag: "", ports: ["Bar", "Kotor", "Lipci"] },
    Senegal: { flag: "", ports: ["Dakar", "M’Bao Oil Terminal"] },
    "Saudi Arabia": {
      flag: "",
      ports: [
        "Jeddah",
        "Ju’aymah Crude & LPG Terminals",
        "Ras al Khafji",
        "Ras Tanura",
        "Yanbu",
      ],
    },
    "São Tomé and Príncipe": { flag: "", ports: ["Santo Antonio", "Sao Tome"] },
    Samoa: { flag: "", ports: ["Apia"] },
    Spain: {
      flag: "",
      ports: [
        "Abra",
        "Algeciras",
        "Alicante",
        "Almeria",
        "Aviles",
        "Barcelona",
        "Bilbao",
        "Burriana",
        "Cadiz",
        "Cala Figuera",
        "Cartagena",
        "Castellon",
        "Castro-Urdiales",
        "Ceuta",
        "Corcubion",
        "Corunna (La Coruña)",
        "Escombreras",
        "Ferrol",
        "Gijon",
        "Huelva",
        "La Coruna",
        "Mahon",
        "Malaga",
        "Melilla",
        "Palma",
        "Pasajes",
        "Puerto De Santa Maria",
        "Puerto Real",
        "Puerto Santa Maria",
        "Punta Ceballos Tanker Terminal",
        "Punta Lucero Tanker Terminal",
        "Raos",
        "Rota",
        "San Esteban de Pravia",
        "San Sebastian",
        "Santander",
        "Santurce",
        "Seville",
        "Tarragona",
        "Torrevieja",
        "Valencia",
        "Vigo",
        "Zorroza",
      ],
    },
    Suriname: { flag: "", ports: ["Paramaribo"] },
    Sudan: {
      flag: "",
      ports: ["Marsa Bashayer Export Terminal", "Port Sudan", "Suakin"],
    },
    "St. Vincent": {
      flag: "",
      ports: ["Arnos Vale", "Campden Park Bay", "Kingstown"],
    },
    "St. Lucia": {
      flag: "",
      ports: ["Castries", "Cul-de-Sac", "Pointe Seraphine"],
    },
    "St. Kitts & Nevis": { flag: "", ports: ["Basseterre"] },
    "St. Helena Island": { flag: "", ports: ["Jamestown"] },
    "Sri Lanka": {
      flag: "",
      ports: [
        "China Bay",
        "Cod Bay",
        "Colombo",
        "Galle",
        "Malay Cove",
        "Trincomalee",
      ],
    },
    Sweden: {
      flag: "",
      ports: [
        "Ahus",
        "Ala",
        "Axelsvik Oil Terminal",
        "Bado",
        "Bollsta",
        "Braviken",
        "Brofjorden",
        "Bulkhamnen",
        "Djuro",
        "Domsjo",
        "Donso",
        "Edstrandsbassangen",
        "Fredriksskans",
        "Frihamnen",
        "Froland",
        "Gastgivarehagen",
        "Gavle",
        "Geffe",
        "Goteborg",
        "Gothenburg",
        "Granudden",
        "Hallstavik",
        "Halmstad",
        "Hammarbyhamnen",
        "Hargshamn",
        "Harnosand",
        "Helsingborg",
        "Hudiksvall",
        "Husum",
        "Kage",
        "Kalix",
        "Kalmar",
        "Karlsborg",
        "Karlshall",
        "Karlshamn",
        "Karlskrona",
        "Karlstad",
        "Karlsvik",
        "Karskar",
        "Kolo Harbour",
        "Kubikenborg",
        "Landskrona",
        "Langror",
        "Limhamn",
        "Lomma",
        "Loudden",
        "Lugnvik",
        "Lulea",
        "Lysekil",
        "Malmo",
        "Marstrand",
        "Norrkoping",
        "Nyhamn",
        "Nykoping",
        "Nynashamn",
        "Ohmans",
        "Ornskoldsvik",
        "Orrskar",
        "Ortviken",
        "Oskarshamn",
        "Ostrand",
        "Oxelosund",
        "Oxhaga Harbour",
        "Pampus Harbour",
        "Paskallavik",
        "Pitea",
        "Ramshall",
        "Ronneby",
        "Ronnskar",
        "Rya Harbour",
        "Sandarne",
        "Skelleftea",
        "Skeppsbron",
        "Skoghall",
        "Skredsvik",
        "Skutskar",
        "Slite",
        "Soderhamn",
        "Sodertalje & Sodertalje Canal",
        "Solvesborg",
        "Soraker",
        "Stadsgarden",
        "Stenungsund",
        "Stilleryd Harbour",
        "Stockholm",
        "Stockvik",
        "Stormskar Oil Terminal",
        "Stroemstad",
        "Stugsund",
        "Sundsvall",
        "Sutudden Harbour",
        "Tallbacken",
        "Trelleborg",
        "Tunadalshamnen",
        "Uddebo",
        "Uddevalla",
        "Umea",
        "Utansjo",
        "Vaja",
        "Vallvik",
        "Varberg",
        "Vartahamnen",
        "Vasteras",
        "Vastervik",
        "Wallhamn",
      ],
    },
    Syria: { flag: "", ports: ["Banias", "Latakia", "Tartous"] },
    Tunisia: {
      flag: "",
      ports: [
        "Bizerte",
        "Gabes",
        "La Goulette",
        "La Skhirra",
        "Rades",
        "Sfax",
        "Tunis",
      ],
    },
    "Trinidad & Tobago": {
      flag: "",
      ports: ["Brighton", "Point Fortin", "Port of Spain", "Tembladora"],
    },
    Togo: { flag: "", ports: ["Kpeme", "Lome"] },
    Thailand: {
      flag: "",
      ports: [
        "Bang Hua Sua",
        "Bangkok",
        "Chognonsri Marine Terminal",
        "Klong Toey",
        "Koh Si Chang Transhipment Area",
        "Kohsichang TPP",
        "Krung Thep",
        "Laem Chabang",
        "Phuket",
        "Sathupradit",
        "Sattahip",
        "Sima Seaport",
        "Sriracha Harbour",
        "Sriracha Oil Terminals",
      ],
    },
    Tanzania: {
      flag: "",
      ports: [
        "Dar es Salaam",
        "Mjimwema Oil Terminal",
        "Mtwara",
        "Tanga",
        "Zanzibar City",
      ],
    },
    Taiwan: {
      flag: "",
      ports: [
        "Kaohsiung",
        "Keelung",
        "Sha Lung Oil Terminal",
        "Ta-Lin-Pu Offshore Oil Terminal",
        "Tanshui",
        "Yun-An LNG Terminal",
      ],
    },
    Turkey: {
      flag: "",
      ports: [
        "Ambarli",
        "Bandirma",
        "Bodrum",
        "Borusan",
        "Canakkale",
        "Derince",
        "Edincik",
        "Fethiye",
        "Gemlik",
        "Haydarpasa",
        "Isdemir",
        "Iskenderun",
        "Istanbul",
        "Izmir",
        "Izmit",
        "Karakoy",
        "Marmaris",
        "Mersin",
        "Pirs Ekindzhiler",
        "Samsun",
        "Sinop",
        "Tutuncifilik",
        "Yarımca",
      ],
    },
    "United Arab Emirates": {
      flag: "",
      ports: [
        "Ajman",
        "Das Island",
        "Dubai",
        "Fateh Terminal",
        "Jebel Ali",
        "Port Khalid",
        "Port Rashid",
        "Fujairah",
        "Sharjah",
      ],
    },
    Ukraine: {
      flag: "",
      ports: [
        "Azovstal",
        "Feodosia",
        "Illyichevsk",
        "Kerch",
        "Kherson",
        "Mariupol",
        "Odessa",
        "Reni",
        "Sevastopol",
        "Theodosia",
        "Zhdanov",
      ],
    },
    "United Kingdom": {
      flag: "",
      ports: [
        "Aberdeen",
        "Appledore",
        "Arbroath",
        "Ardrossan",
        "Avonmouth",
        "Ayr",
        "Ballylumford",
        "Barrow-in-Furness",
        "Barry",
        "Barton",
        "Belfast",
        "Bideford",
        "Bird Port",
        "Birkenhead",
        "Blyth",
        "Bowling",
        "Braefoot Bay",
        "Brightlingsea",
        "Bristol",
        "Brixham",
        "Brodick Harbour",
        "Bromborough",
        "Burntisland",
        "Burray",
        "Cairnryan",
        "Campbeltown",
        "Canvey Island",
        "Cardiff",
        "Cattawater Harbour",
        "Charlestown",
        "Chatham Docks",
        "Colchester",
        "Coolkeragh",
        "Coryton",
        "Cowes",
        "Cromarty Firth",
        "Dagenham",
        "Dartmouth",
        "Dover",
        "Dover Strait",
        "Dundee",
        "Dunoon",
        "Eastham",
        "Eccles",
        "Ellesmere Port",
        "Falmouth",
        "Fawley",
        "Felixstowe",
        "Fingringhoe",
        "Finnart",
        "Fishguard",
        "Flotta Terminal",
        "Folkestone",
        "Forth Ports",
        "Fowey",
        "Garston",
        "Glasgow",
        "Gourock",
        "Grangemouth",
        "Granton",
        "Gravesend",
        "Grays",
        "Great Yarmouth",
        "Greenock",
        "Greenwich",
        "Grimsby",
        "Hamble",
        "Hartlepool",
        "Harwich",
        "Heysham",
        "Holm",
        "Holyhead",
        "Hound Point",
        "Howden",
        "Howdendyke",
        "Hull",
        "Immingham",
        "Ince",
        "Invergordon",
        "Inverness",
        "Ipswich",
        "Irlam",
        "Irvine",
        "Isle Of Grain",
        "Killingholme",
        "King’s Lynn",
        "Kingsnorth",
        "Kirkcaldy",
        "Kirkwall",
        "Lamlash Harbour",
        "Lancaster",
        "Largs",
        "Larne",
        "Leith",
        "Lerwick",
        "Lisahally Port",
        "Liverpool",
        "London",
        "Londonderry",
        "Longhope",
        "Lowestoft",
        "Lydney",
        "Lyness",
        "Manchester",
        "Manchester Ship Canal",
        "Maydown",
        "Medway Ports",
        "Methil",
        "Middlesbrough",
        "Milford Docks",
        "Milford Haven",
        "Mistley",
        "Montrose",
        "Neath",
        "New Holland",
        "Newcastle upon Tyne",
        "Newhaven",
        "Newlyn",
        "Nigg Oil Terminal",
        "North Woolwich",
        "Oakham Ness",
        "Oban",
        "Old Kilpatrick",
        "Otterham",
        "Par",
        "Partington",
        "Pembroke",
        "Penryn",
        "Penzance",
        "Peterhead Bay Harbour",
        "Peterhead Harbours",
        "Plymouth",
        "Poole",
        "Port Henry",
        "Port Lamont",
        "Port Talbot",
        "Portree",
        "Portsmouth",
        "Purfleet",
        "Queenborough",
        "Redcar",
        "Ridham Dock",
        "Rochester",
        "Rosyth",
        "Rothesay",
        "Rowhedge",
        "Runcorn",
        "Salford",
        "Salt Island",
        "Saltburn",
        "Saltend",
        "Scalloway",
        "Scapa Flow",
        "Scrabster",
        "Seaham",
        "Seal Sands",
        "Sharpness and Gloucester",
        "Shell Haven",
        "Shoreham",
        "Silvertown",
        "Southampton",
        "St Mary’s (Scilly Islands)",
        "Stanlow",
        "Stornoway",
        "Stranraer",
        "Sullom Voe",
        "Sunderland",
        "Swansea",
        "Teesport",
        "Teignmouth",
        "Thamesport",
        "Thetwall",
        "Tilbury",
        "Torbay Harbour",
        "Torquay",
        "Totnes",
        "Tranmere Oil Terminal",
        "Truro",
        "Tyne",
        "Warrington",
        "Wemyss Bay",
        "Weston Point",
        "Whitehaven",
        "Wick",
        "Wivenhoe",
        "Workington",
      ],
    },
    "United States": {
      flag: "",
      ports: [
        "Aberdeen",
        "Baltimore",
        "Baton Rouge",
        "Boston",
        "Brunswick",
        "Camden",
        "Charleston",
        "Chester",
        "Chicago",
        "Cleveland",
        "Columbia",
        "Corpus Christi",
        "Duluth-Superior",
        "Dundalk",
        "Dutch Harbor",
        "East Bay",
        "Eddystone",
        "El Segundo Terminal",
        "Elizabeth",
        "Eufaula",
        "Eureka",
        "Everett",
        "Everglades",
        "Fairport Harbor",
        "Fall River",
        "Ferndale",
        "Fort Lauderdale",
        "Fort Pierce",
        "Freeport",
        "Galena Park",
        "Galveston",
        "Geismar",
        "Girard Point",
        "Grays Harbor",
        "Greens Bayou",
        "Greenwich Point",
        "Gretna",
        "Groton",
        "Gulfport",
        "Haines",
        "Hampton Roads",
        "Hawkins Point",
        "Hercules",
        "Hillsborough Bay",
        "Hilo",
        "Honolulu",
        "Hoquiam",
        "Houston",
        "Humboldt Bay",
        "Jacintoport",
        "Jacksonville",
        "Jeffries Point",
        "Juneau",
        "Key West",
        "Kodiak",
        "Lake Calumet Harbor",
        "Lake Charles",
        "Lemont",
        "Locust Point",
        "Long Beach",
        "Los Angeles",
        "Lummus Island",
        "Manchester",
        "March Point",
        "Marcus Hook",
        "Mare Island",
        "Marrero",
        "Martinez",
        "McDuffie Island",
        "Melville",
        "Meraux",
        "Miami",
        "Milwaukee",
        "Mobile",
        "Montgomery",
        "Morehead City",
        "National City",
        "Nederland",
        "New Bedford",
        "New Haven",
        "New Jersey",
        "New London",
        "New Orleans",
        "New York & New Jersey",
        "Newark",
        "Newport (Rhode Island)",
        "Newport News",
        "Nikiski",
        "Nome",
        "Norfolk",
        "North Kingstown",
        "Northport",
        "Northville",
        "Oleum",
        "Orange",
        "Ozol",
        "Palm Beach",
        "Panama City",
        "Pasadena",
        "Paulsboro",
        "Penns Grove",
        "Pennsauken",
        "Pensacola",
        "Perth Amboy",
        "Philadelphia",
        "Phoenix City",
        "Piney Point",
        "Pittsburg",
        "Port Arthur",
        "Port Canaveral",
        "Port Chester Harbor",
        "Port Covington",
        "Port Everglades",
        "Port Huron",
        "Port Isabel",
        "Port Jefferson",
        "Port Manatee",
        "Port Neches",
        "Port Newark",
        "Port Richmond",
        "Port San Luis",
        "Port St Joe",
        "Port Sutton",
        "Port Townsend",
        "Portland (Maine)",
        "Portland (Oregon)",
        "Portsmouth",
        "Portsmouth (New Hampshire)",
        "Providence",
        "Rattlesnake",
        "Revere",
        "Richmond (Virginia)",
        "Riverhead Terminal",
        "Rockport",
        "Sabine",
        "Salem",
        "San Diego",
        "San Francisco",
        "San Pedro Harbor",
        "Sandwich",
        "Santa Barbara",
        "Savannah",
        "Searsport",
        "Seattle",
        "Selby",
        "Selma",
        "Seward",
        "Sitka",
        "Skagway",
        "Smith’s Bluff",
        "South Locust Point",
        "Sparrow’s Point",
        "St Bernard Port",
        "St Petersburg",
        "Stamford Harbor",
        "Stockton",
        "Superior",
        "Tacoma",
        "Tampa",
        "Texas City",
        "Texport",
        "Three Mile Creek",
        "Tiverton",
        "Tuscaloosa",
        "Unalaska",
        "Valdez",
        "Vallejo",
        "Vancouver",
        "Weedon Island",
        "West Wego",
        "Whittier",
        "Wilmington (Delaware)",
        "Wilmington (North Carolina)",
        "Winterport",
        "Yorktown",
      ],
    },
    Uruguay: {
      flag: "https://flagcdn.com/w320/uy.png",
      ports: ["Montevideo", "Nueva Palmira", "Paysandu"],
    },
    Venezuela: {
      flag: "https://flagcdn.com/w320/ve.png",
      ports: [
        "Alcasa",
        "Amuay Bay",
        "Bachaquero",
        "Bajo Grande Refinery",
        "Borburata",
        "Caripito",
        "Cumarebo",
        "El Chaure",
        "El Palito",
        "El Tablizo",
        "Guaraguao",
        "Guaranao",
        "Guiria",
        "La Estacada",
        "La Guaira",
        "Las Piedras",
        "Los Cocos",
        "Maracaibo",
        "Moron",
        "Palua",
        "Pamatacual",
        "Paradero",
        "Pertigalete",
        "Puerto Cabello",
        "Puerto La Cruz",
        "Puerto Miranda",
        "Puerto Ordaz",
        "Punta Cardon",
        "Punta Cuchillo",
        "Punta de Palmas",
        "San Felix",
        "San Lorenzo",
        "Venterminales",
      ],
    },

    "Virgin Islands (US)": {
      flag: "https://flagcdn.com/w320/vi.png",
      ports: [
        "Charlotte Amalie",
        "Christiansted",
        "Frederiksted",
        "Hovic",
        "Limetree Bay",
        "Port Alucroix",
        "St Thomas",
        "Third Port",
      ],
    },
    Vietnam: {
      flag: "https://flagcdn.com/w320/vn.png",
      ports: [
        "Ben Nghe",
        "Cho-Lon",
        "Danang",
        "Haiphong",
        "Ho Chi Minh City",
        "Nha Be",
        "Saigon",
      ],
    },
    Yemen: {
      flag: "https://flagcdn.com/w320/ye.png",
      ports: [
        "Aden",
        "Hodeldah",
        "Khalf Harbour",
        "Little Aden",
        "Ma’alla Terminal",
        "Mokha",
        "Mukalla",
        "Ras Alkatheeb",
        "Saleef",
      ],
    },
  };

  // ISO-2 map for the countries/regions you listed (FlagCDN wants lowercase ISO2)
  const ISO2 = {
    // A
    Antigua: "ag",
    Angola: "ao",
    Algeria: "dz",
    Albania: "al",
    Argentina: "ar",
    "Ascension Island": "sh", // fallback to Saint Helena (parent)
    Aruba: "aw",
    Australia: "au",
    Azores: "pt", // fallback to Portugal (parent)

    // B
    Bahamas: "bs",
    Bahrain: "bh",
    Bangladesh: "bd",
    Barbados: "bb",
    Belgium: "be",
    Belize: "bz",
    Benin: "bj",
    Bermuda: "bm",
    Brazil: "br",
    "Brunei Darussalam": "bn",
    Bulgaria: "bg",

    // C
    "Cameroon Republic": "cm", // Cameroon
    Canada: "ca",
    "Cayman Islands": "ky",
    "Cape Verde Islands": "cv", // Cabo Verde
    "Canary Islands": "es", // fallback to Spain (parent)
    Chile: "cl",
    China: "cn",
    "Cocos Islands": "cc",
    "Christmas Island": "cx",
    Colombia: "co",
    "Costa Rica": "cr",
    "Congo (Democratic Republic)": "cd",
    "Congo (Republic of Congo)": "cg",
    Comoros: "km",
    Croatia: "hr",
    Cuba: "cu",
    Cyprus: "cy",

    // D–F
    Denmark: "dk",
    Ecuador: "ec",
    "Dominican Republic": "do",
    Dominica: "dm",
    Djibouti: "dj",
    Egypt: "eg",
    Fiji: "fj",
    "Faroe Islands": "fo",
    "Falkland Islands": "fk",
    Estonia: "ee",
    Eritrea: "er",
    "Equatorial Guinea": "gq",
    "El Salvador": "sv",
    Finland: "fi",
    France: "fr",
    "French Polynesia": "pf",

    // G
    Georgia: "ge",
    Gambia: "gm",
    Gabon: "ga",
    Germany: "de",
    Gibraltar: "gi",
    Ghana: "gh",
    Greece: "gr",
    Guyana: "gy",
    "Guinea-Bissau": "gw",
    Guinea: "gn",
    Guatemala: "gt",
    Guam: "gu",
    Guadeloupe: "gp",
    Grenada: "gd",
    Greenland: "gl",
    Honduras: "hn",
    Haiti: "ht",
    "Hong Kong": "hk",
    Iceland: "is",
    India: "in",
    Indonesia: "id",
    Iran: "ir",
    Iraq: "iq",
    Ireland: "ie",
    Israel: "il",
    "Isle of Man": "im",
    Italy: "it",
    Jamaica: "jm",
    "Ivory Coast": "ci",
    Japan: "jp",
    Kenya: "ke",
    Jordan: "jo",
    Kiribati: "ki",
    "North Korea": "kp",
    "South Korea": "kr",
    Kuwait: "kw",
    Latvia: "lv",
    Lebanon: "lb",
    Liberia: "lr",
    Libya: "ly",
    Madeira: "pt",
    Madagascar: "mg",
    Maldives: "ml",
    Lithuania: "lt",
    Malaysia: "my",
    Mauritius: "mu",
    Mauritania: "mr",
    Martinique: "mq",
    Malta: "mt",
    Mexico: "mx",
    Myanmar: "mm",
    Mozambique: "mz",
    Morocco: "ma",
    Monaco: "mc",
    Micronesia: "fm",
    Nauru: "nr",
    Namibia: "na",
    Netherlands: "nl",
    "New Caledonia": "nc",
    "Netherlands Antilles": "nl", // deprecated (fallback to NL)
    "New Zealand": "nz",
    Nigeria: "ng",
    Nicaragua: "ni",
    Norway: "no",
    "Papua New Guinea": "pg",
    Panama: "pa",
    Pakistan: "pk",
    Oman: "om",
    Peru: "pe",
    Philippines: "ph",
    "Puerto Rico": "pr",
    Portugal: "pt",
    Poland: "pl",
    Qatar: "qa",
    Romania: "ro",
    Reunion: "re",
    Russia: "ru",
    "South Africa": "za",
    Somalia: "so",
    "Solomon Islands": "sb",
    Slovenia: "si",
    Singapore: "sg",
    "Sierra Leone": "sl",
    Seychelles: "sc",
    "Serbia & Montenegro": "rs", // fallback to Serbia
    Senegal: "sn",
    "Saudi Arabia": "sa",
    "São Tomé and Príncipe": "st",
    Samoa: "ws",
    Spain: "es",
    Suriname: "sr",
    Sudan: "sd",
    "St. Vincent": "vc",
    "St. Lucia": "lc",
    "St. Kitts & Nevis": "kn",
    "St. Helena Island": "sh",
    "Sri Lanka": "lk",
    Sweden: "se",
    Syria: "sy",
    Tunisia: "tn",
    "Trinidad & Tobago": "tt",
    Togo: "tg",
    Thailand: "th",
    Tanzania: "tz",
    Taiwan: "tw",
    Turkey: "tr",
    "United Arab Emirates": "ae",
    Ukraine: "ua",
    "United Kingdom": "gb",
    "United States": "us",
  };

  // Build a valid FlagCDN URL
  const flagUrl = (iso2) =>
    `https://flagcdn.com/w320/${iso2.toLowerCase()}.png`;

  // Fill missing/empty flags safely (uses parent-country fallbacks above)
  for (const [name, obj] of Object.entries(countriesWithPorts)) {
    if (!obj.flag) {
      const code = ISO2[name];
      obj.flag = code ? flagUrl(code) : ""; // keep empty if truly unknown
    }
  }

  const allCountries = Object.entries(countriesWithPorts).map(([name, v]) => ({
    value: name,
    label: name,
    flag: v.flag,
  }));

  const { id } = useParams();
  const location = useLocation();
  const [sortedData, setSortedData] = useState("");
  // 1. Fetch Admin Ships
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewLogistics`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setallShips(res1.data.data.reverse());
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  // 3. Merge and sort once both fetches complete
  useEffect(() => {
    const filteredAllShipsReg = allShipsReg
      .filter((ship) => ship.is_allow)
      .map((ship) => ({ ...ship, isFromReg: true }));

    const allShipsWithFlag = allShips.map((ship) => ({
      ...ship,
      isFromReg: false,
    }));

    const mergedSorted = [...allShipsWithFlag, ...filteredAllShipsReg].sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );

    setSortedData(mergedSorted);
    setFilteredShips(mergedSorted);
  }, [allShips, allShipsReg]);

  // Add an identifier to distinguish Admin Ships and Customer Ships
  const filteredAllShipsReg = allShipsReg
    .filter((ship) => ship.is_allow)
    .map((ship) => ({ ...ship, isFromReg: true })); // Mark as from RegisterShipForSale

  const allShipsWithFlag = allShips.map((ship) => ({
    ...ship,
    isFromReg: false,
  })); // Mark as Admin Ship

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRegionValue, setSelectedRegionValue] = useState("");

  const searchParams = new URLSearchParams(location.search);
  const pageFromUrl = parseInt(searchParams.get("page")) || 1;

  const [itemsPerPage, setItemsPerPage] = useState(8); // Number of cards per page
  useEffect(() => {
    const updateItemsPerPage = () => {
      if (window.innerWidth >= 1850) {
        setItemsPerPage(10); // 2xl screens
      } else {
        setItemsPerPage(8); // Default for other sizes
      }
    };

    updateItemsPerPage(); // Call on mount

    window.addEventListener("resize", updateItemsPerPage);
    return () => window.removeEventListener("resize", updateItemsPerPage);
  }, []);

  const activeShips = filteredShips.filter((ship) => ship.is_status === true);
  const totalPages =
    itemsPerPage > 0 ? Math.ceil(activeShips.length / itemsPerPage) : 1;

  useEffect(() => {
    if (pageFromUrl >= 1 && pageFromUrl <= totalPages) {
      setCurrentPage(pageFromUrl);
      setRefPage(pageFromUrl);
    }
  }, [pageFromUrl, totalPages]);

  const totalCombinedPages = Math.ceil(sortedData.length / itemsPerPage);

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setRefPage(page); // Update reference page
      setCurrentPage(page); // Update state (reactive)
      navigate(`/open-cargo?page=${page}`); // Update URL
    }

    if (page >= 1 && page <= totalCombinedPages) {
      localStorage.setItem("currentPage", page); // Save page
      window.scrollTo({ top: 50, behavior: "smooth" }); // Smooth scroll to top

      setTimeout(() => {}, 300); // Adjust delay as needed
    }
  };

  useEffect(() => {
    const savedPage = parseInt(localStorage.getItem("currentPage"));
    if (savedPage && savedPage >= 1 && savedPage <= totalCombinedPages) {
      setCurrentPage(savedPage);
    } else {
      setCurrentPage(1); // Default to 1 if nothing saved
    }
  }, []);

  useEffect(() => {
    const savedPage = parseInt(localStorage.getItem("currentPage"));
    if (savedPage && savedPage >= 1 && savedPage <= totalCombinedPages) {
      setCurrentPage(savedPage);
    } else {
      setCurrentPage(1); // Default to 1 if nothing saved
    }
  }, []);

  const handleSearch = (selectedCountry) => {
    if (!selectedCountry) {
      setFilteredShips(sortedData);
      return;
    }

    const results = sortedData.filter(
      (ship) =>
        ship.flag &&
        selectedCountry &&
        ship.flag.toLowerCase() === selectedCountry.toLowerCase()
    );

    setFilteredShips(results);
  };

  const handleRegionClick = (region) => {
    setSelectedRegion(region);
    setSelectedCountry(null);
  };

  const token = localStorage.getItem("token");

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption?.value || null);
  };

  const handleBack = () => {
    setSelectedCountry(null);
    setSelectedRegion(null);

    setCurrentPage(1);
    setFilteredShips(sortedData);
    setSelectedRegionValue("");
  };

  const [searchValue, setSearchValue] = useState("");

  // Handles search logic
  const handleSearchCapacity = () => {
    if (searchValue.trim() !== "") {
      // your search function here
      console.log("Searching for:", searchValue);
      // e.g., searchByCapacity(searchValue);
    }
  };

  // Handles Enter key
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedShips = filteredShips
    .filter((ship) => ship.is_status === true)
    .slice(startIndex, endIndex);

  const [isScrolled, setIsScrolled] = useState(false);
  // Track scrolling
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [allImages, setallImages] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :", res3);
          setallImages(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  const [Amenities, setAmenities] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewAmenities`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status === 200) {
          console.log("Amenity", res);
          setAmenities(res.data.data);
        } else {
          console.log(res);
        }
      } catch (err) {
        console.log("error2", err);
      }
    }
    fetchdata();
  }, [config.base_url]);

  const [allImagesReg, setAllImagesReg] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res3 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/ship_images_Reg`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res3.data.status === 200) {
          console.log("Images :", res3);
          setAllImagesReg(res3.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  const handleNavigateToSingleShip = (ship) => {
    const route = ship.is_allow
      ? ` /singleShipCharter/${ship.id}`
      : `/singleShip/${ship.id}`;

    navigate(route, {
      state: {
        from: location.pathname,
        page: currentPage, // Store current pagination page
      },
    });
  };

  const rotations = [
    "rotate-[]",
    "rotate-[4deg]",
    "rotate-[-6deg]",
    "rotate-[5deg]",
    "rotate-[-2deg]",
  ];
  const pinPositions = ["top-4 left-1/2 -translate-x-1/2"];
  const positions = [
    { top: "30%", left: "35%" },
    { top: "20%", left: "50%" },
    { top: "40%", left: "60%" },
    { top: "50%", left: "30%" },
    { top: "25%", left: "45%" },
  ];

  const [user, setUser] = useState(null);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewusers`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log("API response:", res2.data);
        if (res2.data.status === 200) {
          console.log("User:", res2);
          setUser(res2.data.data);
        } else {
          console.log(res2);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [token]);

  const currentShip = displayedShips[currentPage];



  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeRegion, setActiveRegion] = useState(null); // clicked region
  const [hoveredRegion, setHoveredRegion] = useState(null); // hovered region
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
        setActiveRegion(null);
        setHoveredRegion(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [selectedShip, setSelectedShip] = useState(null);
  const [CompanyAddress, setCompanyAddress] = useState("");
  const [Company, setCompany] = useState("");
  const [Lychan, setLychan] = useState("");
  const [TypeOfCargo, setTypeOfCargo] = useState("");
  const [Tonnage, setTonnage] = useState("");
  const [LoadingPort, setLoadingPort] = useState("");
  const [DischargePort, setDischargePort] = useState("");
  const [ChartererAcc, setChartererAcc] = useState("");
  const [Commission, setCommission] = useState("");
  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Mobile, setMobile] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false); // Payment plan modal
  const [isOpenModal, setIsOpenModal] = useState(false); // for dropdown
  const [showModal, setShowModal] = useState(false); // for enquiry modal
  const [CreatedAt, setCreatedAt] = useState("");

  const handleOwnerInfo = async (ship) => {
    setSelectedShip(ship); // 👈 save the ship for checkout later

    setEmail(ship.email || "N/A");
    setMobile(ship.phone || "N/A");
    setCreatedAt(ship.created_at);
    setChartererAcc(ship.charterer_account || "N/A");
    setTypeOfCargo(ship.type_of_cargo || "N/A");
    setCompany(ship.company || "N/A");
    setCompanyAddress(ship.company_address || "N/A");
    setName(ship.name || "N/A");
    setEmail(ship.email || "N/A");
    setTonnage(ship.tonnage || "N/A");
    setCommission(ship.commission || "N/A");
    setLoadingPort(ship.loading_port || "N/A");
    setLychan(ship.lychan || "N/A");
    setDischargePort(ship.discharge_port || "N/A");
    // setShipCode(ship.ship_code || "N/A");
    // setShipId(ship.id || "N/A");

    setShowModal(true);
    return;
  };

  const [username, setusername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [Signin, setSignin] = useState("Signin");
  // Validate username
  const validateUsername = (value) => {
    if (!value) {
      setUsernameError("Username is required");
    } else {
      setUsernameError("");
    }
  };

  // Validate password
  const validatePassword = (value) => {
    if (!value) {
      setPasswordError("Password is required");
    } else if (value.length < 4) {
      setPasswordError("Password must be at least 4 characters");
    } else {
      setPasswordError("");
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    const data = {
      email: username,
      password: password,
    };
    try {
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/login`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status === 200) {
        setLoading(false);
        console.log(response);
        localStorage.setItem("token", response.data.token);
        if (response.data.is_admin === true) {
          localStorage.setItem("admin", "t");
          console.log("Admin token:", response.data.token); // ✅ log admin token
          window.location.href = "/adminHome";
        } else {
          window.location.href = "/userHome";
        }
      } else {
        console.log(response);
        toast.error(response.data.message, {
          autoClose: 3000,
          position: "top-right",
        });
        setLoading(false);
      }
    } catch (err) {
      console.log("error2", err);
      toast.error("Error", {
        autoClose: 3000,
        position: "top-right",
      });
      setLoading(false);
    }
  };

  const [showPassword, setShowPassword] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");

  const [confirmPassword, setConfirmPassword] = useState("");
  const [image, setImage] = useState("");

  // Error states
  const [emailError, setEmailError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);

  // Email validation (simple regex)
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!emailRegex.test(value));
  };

  const validateMobile = (value) => {
    const mobileRegex = /^\+\d{7,15}$/;
    setMobileError(!mobileRegex.test(value));
  };

  // Confirm Password validation (must match Password)
  const validateConfirmPassword = (value) => {
    setConfirmPasswordError(value !== password);
  };

  const handleSubmitSignup = async () => {
    // Run all validations first
    validateUsername(username);
    validateEmail(Email);
    validateMobile(Mobile);
    validatePassword(password);
    validateConfirmPassword(confirmPassword);

    // Check for any errors or empty required fields
    if (
      usernameError ||
      emailError ||
      mobileError ||
      passwordError ||
      confirmPasswordError ||
      !firstName ||
      !lastName ||
      !username ||
      !Email ||
      !Mobile ||
      !password ||
      !confirmPassword
    ) {
      toast.error("Please fix form validation errors before submitting.", {
        autoClose: 1500,
        position: "top-right",
      });
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("email", Email);
    formData.append("username", username);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("phone", Mobile);
    formData.append("address", address);
    formData.append("password", password);
    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/signup`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === 200) {
        toast.success("Registered Successfully", {
          autoClose: 1500,
          position: "top-right",
          onClose: () => navigate("/login"),
        });
      } else if (
        response.data.status === 400 &&
        response.data.message === "Email already exists"
      ) {
        toast.error("Email already exists", {
          autoClose: 1500,
          position: "top-right",
        });
      } else if (
        response.data.status === 400 &&
        response.data.message === "Username already exists"
      ) {
        toast.error("Username already exists", {
          autoClose: 1500,
          position: "top-right",
        });
      } else {
        toast.error("Something went wrong. Try again.", {
          autoClose: 1500,
          position: "top-right",
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Network error. Please try again.", {
        autoClose: 1500,
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

  const handleForgotPassword = async () => {
    if (!resetEmail) {
      toast.error("Please enter your email");
      return;
    }
    setResetLoading(true);
    try {
      const res = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/forgot-password/`,
        {
          email: resetEmail,
        }
      );
      if (res.data.status === 200) {
        toast.success("Reset link sent to your email");
        setSignin("Signin");
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setResetLoading(false);
    }
  };

  const [expandedShipId, setExpandedShipId] = useState(null);

 useEffect(() => {
  const params = new URLSearchParams(location.search);
  const shipIdFromUrl = params.get("shipId");

  // 👇 Add the logs right here, near the top of the effect
  // console.log("Effect ran");
  // console.log("ShipId from URL:", shipIdFromUrl);
  // console.log("Ships loaded:", displayedShips.length);
  // console.log("Expanded ship:", expandedShipId);

  if (!shipIdFromUrl) return;

  const shipIdNum = parseInt(shipIdFromUrl);

  if (!allShips.length || !filteredShips.length || !displayedShips.length) return;

  const indexInFiltered = filteredShips.findIndex((s) => s.id === shipIdNum);
  if (indexInFiltered === -1) return;

  const targetPage = Math.floor(indexInFiltered / itemsPerPage) + 1;
  const currentPage = Number(new URLSearchParams(location.search).get("page")) || 1;

  if (currentPage !== targetPage) {
    const newParams = new URLSearchParams(location.search);
    newParams.set("page", targetPage);
    newParams.set("shipId", shipIdFromUrl);
    navigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
    return;
  }

  const shipData = displayedShips.find((s) => s.id === shipIdNum);
  if (shipData && expandedShipId !== shipData.id) {
    setTimeout(() => {
      setExpandedShipId(shipData.id);

      const cleanParams = new URLSearchParams(location.search);
      cleanParams.delete("shipId");
      navigate(`${location.pathname}?${cleanParams.toString()}`, { replace: true });

      const el = document.getElementById(`ship-${shipData.id}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "end" });
    }, 300);
  }
}, [
  location.search,
  allShips,
  filteredShips,
  displayedShips,
  itemsPerPage,
  expandedShipId,
  navigate,
  location.pathname,
]);




  const toggleExpand = (shipId) => {
    setExpandedShipId((prev) => (prev === shipId ? null : shipId));
  };

  const handleShare = (shipId) => {
    const shareUrl = `https://mariniz.com/open-cargo?shipId=${shipId}`;
    const message = `Check out this ship available for charter:\n${shareUrl}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div>
      <div className="">
       <NewHomeNav/>

        <section className="bg-gradient-to-r from-[#2e5775] to-[#326e99] pb-10  xl:px-[20px]  xm:px-[10px] xm:py-[20px]">
          <h1 className="text-gray-50 text-2xl text-center font-bold py-5">
            Cargo Ready To Load
          </h1>
          <div className=" py-5  xs:px-2">
            {/* main */}
            <div className="  mt-3">
              {/* left side */}
              {selectedView === "ship" && (
                <div className="">
                  <div className=" w-[100%]  px-5 xl:px-4  text-[#d1a460] text-xl m-auto">
                    <h1 className="font-semibold text-xl  hidden xm:block">
                      Looking For
                    </h1>
                    {/* select region */}
                    {/* Show Region Select only when no region is selected */}
                    <div className="w-full xm:mt-3 mb-5  xm:mb-8">
                      <div className="flex gap-5 justify-center flex-wrap">
                        <h1 className="font-semibold text-xl mt-2 xm:hidden">
                          Looking For
                        </h1>
                        {/* Type of ship */}
                        <div className="w-[200px] xm:w-full">
                          <select
                            className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
                            name="TypeOfCargo"
                            id="TypeOfCargo"
                          >
                            <option hidden selected value="">
                              - Type of Cargo -
                            </option>
                            <option
                              disabled
                              className="text-gray-500 font-semibold"
                              value=""
                            >
                              Categories
                            </option>

                            {[
                              ...new Set(
                                displayedShips.map((item) => item.type_of_cargo)
                              ),
                            ].map((cargo, index) => (
                              <option
                                key={index}
                                value={cargo}
                                className="text-gray-500"
                              >
                                {cargo}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Open Area */}
<div className="w-[200px] xm:w-full">
 

  <div className="flex-1 relative" id="LoadinPort">
    {/* Trigger */}
    <div
      className="w-full rounded border cursor-pointer capsule-openarea p-2 bg-white flex justify-between items-center"
      onClick={() => setDropdownOpen((prev) => !prev)}
    >
      {selectedCountry && selectedPort
        ? `${selectedPort}, ${selectedCountry}`
        : selectedCountry
        ? `${selectedCountry} — Select Port`
        : "-Loading Port-"}
      <i className="fa-solid fa-chevron-down ml-2 text-sm"></i>
    </div>

    {/* Dropdown */}
    {dropdownOpen && (
      <div
        className="absolute top-full left-0 mt-1 shadow-md bg-white border rounded z-50
                   max-h-[360px] overflow-hidden flex"
        onMouseLeave={() => setDropdownOpen(false)}
      >
        {/* Left: Countries w/ hover */}
        <div className="w-64 max-h-[360px] overflow-y-auto">
          {/* Optional: search */}
          <div className="p-2 border-b">
            <input
              placeholder="Search country..."
              className="w-full p-2 border rounded text-sm"
              value={countryQuery}
              onChange={(e) => setCountryQuery(e.target.value)}
            />
          </div>

          {allCountries
            .filter(c =>
              !countryQuery?.trim()
                ? true
                : c.label.toLowerCase().includes(countryQuery.toLowerCase())
            )
            .map((country) => (
              <div
                key={country.value}
                className={`flex items-center gap-2 py-2 px-3 hover:bg-gray-100 cursor-pointer ${
                  hoverCountry === country.value ? "bg-gray-100" : ""
                }`}
                onMouseEnter={() => setHoverCountry(country.value)}
                onClick={() => {
                  // allow selecting country without port
                  setSelectedCountry(country.value);
                  setSelectedPort(""); // reset port
                }}
              >
                <img src={country.flag} alt="" className="w-5 h-5 rounded-sm" />
                <span className="truncate">{country.label}</span>
              </div>
            ))}
        </div>

        {/* Right: Ports for hovered/selected country */}
        <div className="w-80 border-l max-h-[360px] overflow-y-auto">
          <div className="p-2 border-b bg-gray-50 text-sm font-semibold">
            {hoverCountry || selectedCountry || "Ports"}
          </div>
          <div className="p-2">
            {(() => {
              const cName = hoverCountry || selectedCountry;
              const ports =
                cName && countriesWithPorts[cName]
                  ? countriesWithPorts[cName].ports
                  : [];

              if (!cName)
                return <div className="text-sm text-gray-500">Hover a country to see ports</div>;

              if (!ports?.length)
                return <div className="text-sm text-gray-500">No ports listed</div>;

              return ports.map((port) => (
                <div
                  key={port}
                  className="py-2 px-2 rounded hover:bg-gray-100 cursor-pointer text-sm"
                  onClick={() => {
                    setSelectedCountry(cName);
                    setSelectedPort(port);
                    setDropdownOpen(false);
                  }}
                >
                  {port}
                </div>
              ));
            })()}
          </div>
        </div>
      </div>
    )}
  </div>
</div>
  
  <div className="w-[200px]  xm:w-full  ">
  

  <div className="flex-1 relative" id="DischargePort">
    {/* Trigger */}
    <div
      className="w-full rounded border cursor-pointer capsule-openarea p-2 bg-white flex justify-between items-center"
      onClick={() => setDropdownOpenDis((prev) => !prev)}
    >
      {dischargeCountry && DischargePort
        ? `${DischargePort}, ${dischargeCountry}`
        : dischargeCountry
        ? `${dischargeCountry} — Select Port`
        : "-Discharge Port-"}
      <i className="fa-solid fa-chevron-down ml-2 text-sm"></i>
    </div>

    {/* Dropdown */}
    {dropdownOpenDis && (
      <div
        className="absolute top-full left-0 mt-1 shadow-md bg-white border rounded z-50
                   max-h-[360px] overflow-hidden flex"
        onMouseLeave={() => setDropdownOpenDis(false)}
      >
        {/* Left: Countries w/ hover */}
        <div className="w-64 max-h-[360px] overflow-y-auto">
          <div className="p-2 border-b">
            <input
              placeholder="Search country..."
              className="w-full p-2 border rounded text-sm"
              value={countryQueryDis}
              onChange={(e) => setCountryQueryDis(e.target.value)}
            />
          </div>

          {allCountries
            .filter((c) =>
              !countryQueryDis?.trim()
                ? true
                : c.label.toLowerCase().includes(countryQueryDis.toLowerCase())
            )
            .map((country) => (
              <div
                key={country.value}
                className={`flex items-center gap-2 py-2 px-3 hover:bg-gray-100 cursor-pointer ${
                  hoverCountryDis === country.value ? "bg-gray-100" : ""
                }`}
                onMouseEnter={() => setHoverCountryDis(country.value)}
                onClick={() => {
                  setDischargeCountry(country.value);
                  setDischargePort(""); // reset port
                }}
              >
                <img src={country.flag} alt="" className="w-5 h-5 rounded-sm" />
                <span className="truncate">{country.label}</span>
              </div>
            ))}
        </div>

        {/* Right: Ports */}
        <div className="w-80 border-l max-h-[360px] overflow-y-auto">
          <div className="p-2 border-b bg-gray-50 text-sm font-semibold">
            {hoverCountryDis || dischargeCountry || "Ports"}
          </div>
          <div className="p-2">
            {(() => {
              const cName = hoverCountryDis || dischargeCountry;
              const ports =
                cName && countriesWithPorts[cName]
                  ? countriesWithPorts[cName].ports
                  : [];

              if (!cName)
                return (
                  <div className="text-sm text-gray-500">
                    Hover a country to see ports
                  </div>
                );

              if (!ports?.length)
                return (
                  <div className="text-sm text-gray-500">No ports listed</div>
                );

              return ports.map((port) => (
                <div
                  key={port}
                  className="py-2 px-2 rounded hover:bg-gray-100 cursor-pointer text-sm"
                  onClick={() => {
                    setDischargeCountry(cName);
                    setDischargePort(port);
                    setDropdownOpenDis(false);
                  }}
                >
                  {port}
                </div>
              ));
            })()}
          </div>
        </div>
      </div>
    )}
  </div>
</div>


                       

                        {/* Capacity */}
                        <div className="w-[200px] mb-10 xm:w-full">
                          <select
                            className="w-full h-[45px] xm:rounded cursor-pointer capsule-openarea"
                            name="Capacity"
                            id="Capacity"
                          >
                            <option hidden selected value="">
                              - Capacity-
                            </option>
                            <option
                              disabled
                              className="text-gray-500 font-semibold"
                              value=""
                            >
                              Catagories
                            </option>
                            <option value="Barge" className="text-gray-500">
                              1000 - 5000
                            </option>
                            <option value="Bulk" className="text-gray-500">
                              5000 - 10000
                            </option>
                            <option value="Cargo" className="text-gray-500">
                              10000 - 15000
                            </option>
                            <option value="Container" className="text-gray-500">
                              15000 - 25000
                            </option>
                            <option value="Fishing" className="text-gray-500">
                              25000 - 50000
                            </option>
                            <option
                              value="Multipurpose"
                              className="text-gray-500"
                            >
                              50000 - more
                            </option>
                          </select>
                        </div>

                        <div className="flex gap-3 items-center -mt-10">
                          <button className="bg-gray-50  px-3 py-[10px] rounded-xl w-full ">
                            Clear
                          </button>
                          <button className="bg-[#d1a460] text-gray-50 hover:bg-[#c6a067] px-3 py-[10px] rounded-xl w-full ">
                            Search
                          </button>
                        </div>
                      </div>

                      {/* <div className="">
                                    <div className="w-[300px]  xl:w-[100%] flex-shrink-0">
          <Select
            className=" w-[90%] m-auto"
            options={regions[selectedRegion]}
            placeholder="Select a country"
            value={
              selectedCountry
                ? regions[selectedRegion]?.find((c) => c.label === selectedCountry)
                : null
            }
            onChange={(selectedCountry) => {
              setSelectedCountry(selectedCountry.label);
              handleSearch(selectedCountry.label);
              handleCountryChange(selectedCountry);
            }}
            isSearchable
            getOptionLabel={(e) => (
              <div className="flex items-center gap-2">
                <img src={e.flag} alt="" className="w-5 h-5" />
                {e.label}
              </div>
            )}
          />
          
          
                                    
          
                                     {selectedCountry &&(
                                      <button
                                        className="capsule-3d border border-white  py-3 w-[90%] m-auto mt-10"
                                        onClick={handleBack}
                                      >
                                        <i className="fa-solid fa-arrow-left fa-beat me-2"></i>{" "}
                                        Back to Regions
                                      </button>
                                     ) }
                                    </div>
          
                                    <div>
                                      
                                      
                                    </div>
                                  </div> */}
                    </div>

                    <>
                      <div className=" w-[100%]  m-auto">
                        {/* Display All Ships */}
                        <div className="w-[100%] m-auto">
                          <div className="flex flex-wrap justify-center gap-10 mb-5">
                            {displayedShips.map((ship, index) => (
                              <div
                                id={`ship-${ship.id}`}
                                key={index}
                                onClick={() => toggleExpand(ship.id)}
                                className={`relative border-2 border-[#d1a460] rounded-lg overflow-hidden bg-white shadow-xl py-4 px-3 transition-all duration-500 flex flex-col
  ${
    expandedShipId === ship.id
      ? "w-[500px] h-[350px] xm:h-full z-0 lg:w-[600px]"
      : "w-[330px] lg:w-[600px] mx:h-full hover:scale-105 cursor-pointer  h-[350px] xs:w-full"
  }`}
                              >
                                {/* Main Info + Expanded Details */}
                                <div
                                  className={`transition-all duration-500 ${
                                    expandedShipId === ship.id
                                      ? "flex flex-row gap-4"
                                      : "flex flex-col"
                                  }`}
                                >
                                  {/* Main Card Info */}
                                  <div>
                                    {expandedShipId !== ship.id && (
                                      <>
                                        <i
                                          className={`bx bxs-pin-alt text-2xl -mt-3 text-red-600 absolute ${
                                            pinPositions[
                                              index % pinPositions.length
                                            ]
                                          }`}
                                        ></i>
                                        <div className="py-1 border-b text-start text-lg border-black font-bold text-gray-800">
                                          <p className="bg-[#d1a460] rounded p-2 text-center">
                                            {ship.type_of_cargo}
                                          </p>
                                        </div>
                                        <p className="text-sm py-2 border-b text-start border-black font-bold text-gray-800">
                                          Loading Port :{" "}
                                          {ship.loading_port || "N/A"}
                                        </p>
                                        <p className="text-sm py-2 border-b text-start border-black font-bold text-gray-800">
                                          Discharge Port :{" "}
                                          {ship.discharge_port || "N/A"}
                                        </p>
                                        <p className="font-bold py-2 text-sm text-gray-800 text-start">
                                          Tonnage : {ship.tonnage}
                                        </p>
                                        <p className="font-bold text-start mt-1 text-sm text-gray-800">
                                          Lychan : {ship.lychan}
                                        </p>
                                      </>
                                    )}
                                  </div>

                                  {/* Expanded Details */}
                                  {expandedShipId === ship.id && (
                                    <div className="w-full flex flex-col">
                                      {/* Back Arrow */}
                                      <button
                                        onClick={() => toggleExpand(ship.id)}
                                        className="absolute -left-3 -top-3  text-red-500 px-4 py-2   transition"
                                      >
                                        <h1
                                          onClick={() => toggleExpand(ship.id)}
                                          className="font-semibold"
                                        >
                                          X
                                        </h1>
                                      </button>

                                      {/* Expanded Header */}
                                      <div className="bg-[#d1a460] p-2 mb-2 flex justify-between items-center rounded">
                                        <p className="text-center font-bold text-sm text-gray-800">
                                          {ship.type_of_cargo}, {ship.tonnage},
                                          Open : {ship.loading_port}
                                        </p>
                                        {/* <p className="text-center font-bold text-sm text-gray-800">
                    {ship.id}
                  </p> */}
                                      </div>

                                      {/* Expanded Details List */}
                                      <div className="flex flex-col gap-2">
                                        <div className="bg-[#fdf8f3] xm:h-full xm:overflow-y-hidden h-[200px] overflow-y-scroll border border-[#d1a460] rounded-xl p-2 mb-2 w-full">
                                          <ul className="list-disc py-2 list-inside">
                                            <li className="text-sm text-gray-800">
                                              <span className="font-bold">
                                                Loading Port:
                                              </span>{" "}
                                              {ship.loading_port || "N/A"}
                                            </li>
                                            <li className="text-sm text-gray-800">
                                              <span className="font-bold">
                                                Discharge Port:
                                              </span>{" "}
                                              {ship.discharge_port || "N/A"}
                                            </li>
                                            <li className="text-sm text-gray-800">
                                              <span className="font-bold">
                                                Tonnage:
                                              </span>{" "}
                                              {ship.tonnage}
                                            </li>
                                            <li className="text-sm text-gray-800">
                                              <span className="font-bold">
                                                Lychan:
                                              </span>{" "}
                                              {ship.lychan}
                                            </li>

                                            <li className="text-sm text-gray-800">
                                              <span className="font-bold">
                                                Commission:
                                              </span>{" "}
                                              {ship.commission || "N/A"}
                                            </li>
                                            {ship.brief_description
                                              ?.split("\n")
                                              .map((line, idx) => (
                                                <li
                                                  key={idx}
                                                  className="text-sm text-gray-800 leading-relaxed"
                                                >
                                                  {line}
                                                </li>
                                              ))}
                                            <li className="text-sm text-gray-800">
                                              <span className="font-bold">
                                                Charterer Account:
                                              </span>{" "}
                                              {ship.charterer_account || "N/A"}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>

                                {/* Toggle + Share Buttons */}
                                <div className="mt-auto">
                                  {expandedShipId === ship.id ? (
                                    <div className="flex justify-between gap-2 mt-3">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setIsLoginOpen(true);
                                        }}
                                        className="flex-1 px-2 py-1 bg-[#123d5f] rounded-lg text-white"
                                      >
                                        Owner Informations
                                      </button>
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleShare(ship.id, currentPage);
                                        }}
                                        className="flex-1 bg-green-500 text-white px-2 py-1 rounded-lg flex items-center justify-center gap-2 hover:bg-green-600 transition"
                                      >
                                        <i className="fa-brands fa-whatsapp text-xl"></i>
                                        Share
                                      </button>
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() => toggleExpand(ship.id)}
                                      className="px-2 py-2 mt-3 bg-[#123d5f] rounded-lg text-white w-full"
                                    >
                                      More Information
                                    </button>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* Pagination */}
                          {displayedShips.length > 0 && (
                            <div className="flex justify-center m-auto mt-2 items-center gap-2 ">
                              <button
                                className={`px-4 py-2 bg-[#123d5f] text-white rounded-sm ${
                                  currentPage === 1
                                    ? "opacity-50 cursor-not-allowed"
                                    : "hover:bg-[#172f41ed]"
                                }`}
                                onClick={() =>
                                  handlePageChange(currentPage - 1)
                                }
                                disabled={currentPage === 1}
                              >
                                <i className="fa-solid fa-chevron-left"></i>
                              </button>
                              <span className="px-4 py-2 bg-[#d1a460] text-white rounded-sm">
                                {currentPage}
                              </span>
                              <button
                                className={`px-4 py-2 bg-[#0d2c45] text-white rounded-sm ${
                                  currentPage === totalPages
                                    ? "opacity-50 cursor-not-allowed"
                                    : "hover:bg-[#172f41ed]"
                                }`}
                                onClick={() =>
                                  handlePageChange(currentPage + 1)
                                }
                                disabled={currentPage === totalPages}
                              >
                                <i className="fa-solid fa-chevron-right"></i>
                              </button>
                            </div>
                          )}

                          {isLoginOpen && (
                            <div className="fixed inset-0  bg-black bg-opacity-50 flex justify-center items-center z-50">
                              <div className="bg-gray-50 p-5 py-10  rounded-lg w-[40%] xm:w-[95%] relative">
                                {/* Close button */}
                                <button
                                  className="absolute right-3 top-3 text-gray-500 hover:text-red-500"
                                  onClick={() => setIsLoginOpen(false)}
                                >
                                  ✕
                                </button>

                                {Signin === "Signin" && (
                                  <>
                                    <div>
                                      <img
                                        src={Logo}
                                        className="w-[276px]  m-auto -mt-4 "
                                        alt=""
                                      />
                                      <h1 className="text-center text-[24px] ">
                                        Login
                                      </h1>
                                    </div>
                                    <form
                                      className="flex flex-col mt-3 gap-7"
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          e.preventDefault();
                                          handleSubmit();
                                        }
                                      }}
                                    >
                                      {/* Username Field */}
                                      <input
                                        type="text"
                                        placeholder="Email or Username"
                                        value={username}
                                        onChange={(e) => {
                                          setusername(e.target.value);
                                          validateUsername(e.target.value);
                                        }}
                                        onBlur={() =>
                                          validateUsername(username)
                                        }
                                        className={`w-full px-3 py-2 border ${
                                          usernameError
                                            ? "border-red-500"
                                            : "border-gray-300"
                                        } rounded-lg`}
                                      />

                                      {/* Password Field */}
                                      <div className="relative">
                                        <input
                                          type={
                                            showPassword ? "text" : "password"
                                          }
                                          placeholder="Password"
                                          value={password}
                                          onChange={(e) => {
                                            setPassword(e.target.value);
                                            validatePassword(e.target.value);
                                          }}
                                          onBlur={() =>
                                            validatePassword(password)
                                          }
                                          className={`w-full px-3 py-2 border ${
                                            passwordError
                                              ? "border-red-500"
                                              : "border-gray-300"
                                          } rounded-lg`}
                                        />
                                        <div
                                          className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                          onClick={() =>
                                            setShowPassword(!showPassword)
                                          }
                                        >
                                          {showPassword ? (
                                            <i className="fa-solid fa-eye-slash"></i>
                                          ) : (
                                            <i className="fa-solid fa-eye"></i>
                                          )}
                                        </div>
                                      </div>

                                      {/* Remember Me & Forgot Password */}
                                      <div className="flex justify-between items-center text-sm">
                                        <p>
                                          Not a Member?{" "}
                                          <Link
                                            onClick={() => setSignin("Signup")}
                                            className="text-[#d1a460] font-semibold"
                                          >
                                            Signup
                                          </Link>
                                        </p>
                                        <button
                                          type="button"
                                          onClick={() => setSignin("resetpswd")}
                                          className="text-blue-500 hover:underline"
                                        >
                                          Forgot Password?
                                        </button>
                                      </div>

                                      {/* Login Button */}
                                      <button
                                        type="submit"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleSubmit();
                                        }}
                                        className="w-full bg-[#253356] text-white py-2 rounded-lg hover:bg-[#1b2a4f] disabled:cursor-not-allowed"
                                        disabled={
                                          usernameError ||
                                          passwordError ||
                                          !username ||
                                          !password
                                        }
                                      >
                                        {loading ? (
                                          <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white rounded-full m-auto animate-spin"></span>
                                        ) : (
                                          "Login"
                                        )}
                                      </button>
                                    </form>
                                  </>
                                )}

                                {/* Reset Password View */}
                                {Signin === "resetpswd" && (
                                  <>
                                    <div className="flex justify-between items-center">
                                      <h1 className="text-xl">
                                        Recover Password
                                      </h1>
                                      <button
                                        onClick={() => setSignin("Signin")}
                                      >
                                        <i className="bx bx-arrow-back text-3xl text-blue-500"></i>
                                      </button>
                                    </div>
                                    <p className="mt-2 text-gray-500 text-sm">
                                      Enter your Email and instructions will be
                                      sent to you!
                                    </p>
                                    <form
                                      className="mt-4"
                                      onSubmit={(e) => {
                                        e.preventDefault();
                                        handleForgotPassword();
                                      }}
                                    >
                                      <input
                                        type="email"
                                        placeholder="Enter your Email"
                                        value={resetEmail}
                                        onChange={(e) =>
                                          setResetEmail(e.target.value)
                                        }
                                        className="w-full rounded-lg border py-3 p-2"
                                      />
                                      <button
                                        type="submit"
                                        disabled={resetLoading}
                                        className="mt-4 bg-[#FB9678] w-full p-3 rounded-lg text-white font-semibold hover:bg-[#e97a58]"
                                      >
                                        {resetLoading ? "Sending..." : "RESET"}
                                      </button>
                                    </form>
                                  </>
                                )}

                                {/* Signup */}
                                {Signin === "Signup" && (
                                  <>
                                    <div>
                                      <img
                                        src={Logo}
                                        className="w-[276px]  m-auto -mt-4 "
                                        alt=""
                                      />
                                      <h1 className="text-center text-[24px] ">
                                        Signup
                                      </h1>
                                    </div>

                                    <form
                                      className="flex flex-col gap-7 mx-auto mt-5"
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                          e.preventDefault();
                                          handleSubmitSignup();
                                        }
                                      }}
                                    >
                                      {/* First Name */}
                                      <div className="relative flex gap-10 w-full group">
                                        <input
                                          type="text"
                                          placeholder="First Name"
                                          value={firstName}
                                          onChange={(e) =>
                                            setFirstName(e.target.value)
                                          }
                                          className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
                                        />

                                        <input
                                          type="text"
                                          placeholder="Last Name"
                                          value={lastName}
                                          onChange={(e) =>
                                            setLastName(e.target.value)
                                          }
                                          className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
                                        />
                                      </div>

                                      {/* Username */}
                                      <div className="relative flex gap-10 w-full group">
                                        <input
                                          type="text"
                                          placeholder="Username"
                                          value={username}
                                          onChange={(e) => {
                                            setusername(e.target.value);
                                            validateUsername(e.target.value);
                                          }}
                                          onBlur={() =>
                                            validateUsername(username)
                                          }
                                          className={`w-[50%] px-1 py-1 border-b ${
                                            usernameError
                                              ? "border-red-500"
                                              : "border-gray-400"
                                          } focus:outline-none focus:ring-0 bg-transparent`}
                                        />

                                        <input
                                          type="email"
                                          placeholder="Email"
                                          value={Email}
                                          onChange={(e) => {
                                            setEmail(e.target.value);
                                            validateEmail(e.target.value);
                                          }}
                                          onBlur={() => validateEmail(Email)}
                                          className={`w-[50%] px-1 py-1 border-b ${
                                            emailError
                                              ? "border-red-500"
                                              : "border-gray-400"
                                          } focus:outline-none focus:ring-0 bg-transparent`}
                                        />
                                      </div>

                                      {/* Company Name */}
                                      <div className="relative flex gap-10 w-full group">
                                        <input
                                          type="text"
                                          placeholder="Company Name"
                                          value={companyName}
                                          onChange={(e) =>
                                            setCompanyName(e.target.value)
                                          }
                                          className="w-[50%] px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
                                        />
                                        <div className="w-[50%]">
                                          <input
                                            type="text"
                                            placeholder="Mobile Number"
                                            value={Mobile}
                                            onChange={(e) => {
                                              setMobile(e.target.value);
                                              validateMobile(e.target.value);
                                            }}
                                            onBlur={() =>
                                              validateMobile(Mobile)
                                            }
                                            className={`w-full px-1 py-1 border-b ${
                                              mobileError
                                                ? "border-red-500"
                                                : "border-gray-400"
                                            } focus:outline-none focus:ring-0 bg-transparent`}
                                          />

                                          {/* ✅ Show error message */}
                                          {mobileError && (
                                            <p className="text-red-500 italic text-sm mt-1">
                                              *Please enter a valid mobile
                                              number (e.g., +971501234567).
                                            </p>
                                          )}
                                        </div>
                                      </div>

                                      {/* Address */}
                                      <div className="relative w-full group">
                                        <input
                                          type="text"
                                          placeholder="Address"
                                          value={address}
                                          onChange={(e) =>
                                            setAddress(e.target.value)
                                          }
                                          className="w-full px-1 py-1 border-b border-gray-400 focus:outline-none focus:ring-0 bg-transparent"
                                        />
                                      </div>

                                      {/* Password */}
                                      <div className="relative w-full group">
                                        <input
                                          type={
                                            showPassword ? "text" : "password"
                                          }
                                          placeholder="Password"
                                          value={password}
                                          onChange={(e) => {
                                            setPassword(e.target.value);
                                            validatePassword(e.target.value);
                                          }}
                                          onBlur={() =>
                                            validatePassword(password)
                                          }
                                          className={`w-full px-1 py-1 border-b ${
                                            passwordError
                                              ? "border-red-500"
                                              : "border-gray-400"
                                          } focus:outline-none focus:ring-0 bg-transparent pr-8`} // Add pr-8 for icon space
                                        />

                                        {/* Eye icon */}
                                        <div
                                          className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                          onClick={() =>
                                            setShowPassword(!showPassword)
                                          }
                                        >
                                          {showPassword ? (
                                            <i class="fa-solid fa-eye-slash"></i>
                                          ) : (
                                            <i class="fa-solid fa-eye"></i>
                                          )}
                                        </div>

                                        {passwordError && (
                                          <p className="text-red-500 italic text-sm mt-1">
                                            *Password must be at least 6
                                            characters and contain at least 1
                                            letter and 1 number.
                                          </p>
                                        )}
                                      </div>

                                      {/* Confirm Password */}
                                      <div className="relative w-full group">
                                        <input
                                          type={
                                            showConfirmPassword
                                              ? "text"
                                              : "password"
                                          }
                                          placeholder="Confirm Password"
                                          value={confirmPassword}
                                          onChange={(e) => {
                                            setConfirmPassword(e.target.value);
                                            validateConfirmPassword(
                                              e.target.value
                                            );
                                          }}
                                          onBlur={() =>
                                            validateConfirmPassword(
                                              confirmPassword
                                            )
                                          }
                                          className={`w-full px-1 py-1 border-b ${
                                            confirmPasswordError
                                              ? "border-red-500"
                                              : "border-gray-400"
                                          } focus:outline-none focus:ring-0 bg-transparent pr-8`}
                                        />

                                        {/* Eye icon */}
                                        <div
                                          className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                          onClick={() =>
                                            setShowConfirmPassword(
                                              !showConfirmPassword
                                            )
                                          }
                                        >
                                          {showConfirmPassword ? (
                                            <i class="fa-solid fa-eye-slash"></i>
                                          ) : (
                                            <i class="fa-solid fa-eye"></i>
                                          )}
                                        </div>

                                        {confirmPasswordError && (
                                          <p className="text-red-500 italic text-sm mt-1">
                                            *Passwords do not match.
                                          </p>
                                        )}
                                      </div>

                                      <div className="flex items-center gap-4">
                                        <label
                                          className="text-gray-400 "
                                          htmlFor="image"
                                        >
                                          Image:
                                        </label>
                                        <input
                                          className="px-2  rounded-xl"
                                          type="file"
                                          onChange={(e) =>
                                            setImage(e.target.files[0])
                                          }
                                          id="image"
                                        />
                                      </div>

                                      {/* Signup Button */}
                                      <button
                                        type="submit"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleSubmitSignup();
                                        }}
                                        className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 disabled:cursor-not-allowed transition duration-200 disabled:bg-gray-300"
                                        disabled={
                                          usernameError ||
                                          emailError ||
                                          mobileError ||
                                          passwordError ||
                                          confirmPasswordError ||
                                          !username ||
                                          !Email ||
                                          !Mobile ||
                                          !password ||
                                          !confirmPassword
                                        }
                                      >
                                        {loading ? (
                                          <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin"></span>
                                        ) : (
                                          "Signup"
                                        )}
                                      </button>

                                      {/* Already have account? */}
                                      <div className="text-sm text-center">
                                        Already have an account?{" "}
                                        <Link
                                          onClick={() => setSignin("Signin")}
                                          className="text-[#d1a460] font-semibold"
                                        >
                                          Login
                                        </Link>
                                      </div>
                                    </form>
                                  </>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Go to Top Button */}
        {isScrolled && (
          <div
            className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
          >
            <div
              className="back-to-top px-4 hover:bg-[#615d91]"
              onClick={scrollToTop}
            >
              <i className="fa-solid fa-arrow-up text-2xl"></i>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </div>
  );
}
